import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as e from "react";
import t, { useRef as r, useState as n, useEffect as o } from "react";
import i, { oneOfType as a, shape as s, number as l, string as c, array as u, arrayOf as d, objectOf as p } from "prop-types";
import h from "@material-ui/core/TextField";
import f from "@material-ui/core/Popover";
import { makeStyles as v } from "@material-ui/core/styles";
import g from "@material-ui/core/Button";
import m from "@material-ui/core/Tooltip";
import b from "@material-ui/core/Box";
import y from "@material-ui/core/Divider";
import x from "@material-ui/core/FormControl";
import w from "@material-ui/core/FormHelperText";
import k from "@material-ui/core/InputLabel";
import E from "@material-ui/core/Input";
import S from "@material-ui/core/InputAdornment";
import N from "hoist-non-react-statics";
import { Memo as O, ForwardRef as C } from "react-is";
import R from "@material-ui/core/Slider";
function P(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function j() {
  return (j = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }).apply(this, arguments);
}
function M(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function A(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? M(Object(r), !0).forEach(function (t) {
      P(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : M(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function T(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        o = {},
        i = Object.keys(e);
      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }
  return o;
}
var D,
  I,
  V = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgrey: 11119017,
    darkgreen: 25600,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    grey: 8421504,
    green: 32768,
    greenyellow: 11403055,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgrey: 13882323,
    lightgreen: 9498256,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  },
  _ = function _(e, t) {
    var r = "00000000".concat((16777215 & e).toString(16).toUpperCase()).substr(-6);
    if (!Number.isNaN(t) && void 0 !== t) {
      var n = t.toString(16).toUpperCase();
      1 === n.length && (n = "0".concat(n)), r += n;
    }
    return r;
  },
  W = function W(e) {
    return [(16711680 & e) >> 16, (65280 & e) >> 8, 255 & e];
  },
  z = function z(e) {
    var t = e.map(function (e) {
      var t = e || 0;
      return t < 0 && (t = 0), t > 255 && (t = 255), t;
    });
    return t[3] << 24 | t[0] << 16 | t[1] << 8 | t[2];
  },
  U = function U(e) {
    if (!e || e.length < 3 || e.length > 4) return {
      error: "not valid size"
    };
    var t = e.map(function (e, t) {
      return "string" == typeof e ? "%" !== e[e.length - 1] ? Math.round(Number(e) * (3 === t ? 255 : 1)) : Math.round(Number(e.substring(0, e.length - 1)) / 100 * 255) : Math.round(3 === t ? 255 * e : e);
    });
    return {
      format: "rgb",
      value: z(t),
      rgb: t,
      alpha: t[3]
    };
  },
  F = function F(e) {
    var t,
      r = Number("0x".concat(e.substring(1)));
    if (!Number.isInteger(r) || Number.isNaN(r)) return {
      error: "Not an hex value"
    };
    var n = [];
    if (7 === e.length || 9 === e.length) {
      var o = 9 === e.length ? 8 : 0;
      n[0] = r >> 16 + o & 255, n[1] = r >> 8 + o & 255, n[2] = r >> o & 255, 9 === e.length && (t = 255 & r, n[3] = t, r = z(n));
    } else {
      if (4 !== e.length && 5 !== e.length) return {
        error: "Wrong format"
      };
      var i = 5 === e.length ? 4 : 0;
      n[0] = r >> 8 + i & 15, n[1] = r >> 4 + i & 15, n[2] = r >> i & 15, n[0] |= n[0] << 4, n[1] |= n[1] << 4, n[2] |= n[2] << 4, 5 === e.length && (t = 15 & r, t |= t << 4, n[3] = t), r = z(n);
    }
    return {
      format: "hex",
      value: r,
      rgb: n,
      alpha: t
    };
  },
  q = function q(e) {
    var t = e;
    return "string" == typeof t && (t.indexOf("deg") > -1 ? t = t.substr(0, t.length - 3) : t.indexOf("rad") > -1 ? t = Math.round(t.substr(0, t.length - 3) * (180 / Math.PI)) : t.indexOf("turn") > -1 && (t = Math.round(360 * t.substr(0, t.length - 4))), t = parseFloat(t, 10)), Number.isNaN(t) && (t = 0), t >= 360 && (t %= 360), t < 0 && (t = 0), t;
  },
  L = function L(e) {
    var t = e;
    return "string" == typeof t && (t = parseFloat(t.indexOf("%") > -1 ? t.substring(0, t.length - 1) : t, 10)), Number.isNaN(t) ? t = 0 : t > 100 ? t = 100 : t < 0 && (t = 0), t;
  },
  G = function G(e) {
    if (!e || e.length < 3 || e.length > 4) return {
      error: "Not a valid size"
    };
    var t,
      r = e,
      n = q(r[0]),
      o = L(r[1]),
      i = L(r[2]);
    r[0] = n, r[1] = o, r[2] = i, i /= 100;
    var a = (o /= 100) * (1 - Math.abs(2 * i - 1)),
      s = a * (1 - Math.abs(n / 60 % 2 - 1)),
      l = i - a / 2;
    0 === o ? (t = [i, i, i], l = 0) : t = n >= 0 && n < 60 ? [a, s, 0] : n >= 60 && n < 120 ? [s, a, 0] : n >= 120 && n < 180 ? [0, a, s] : n >= 180 && n < 240 ? [0, s, a] : n >= 240 && n < 300 ? [s, 0, a] : [a, 0, s], t[0] = Math.round(255 * (t[0] + l)), t[1] = Math.round(255 * (t[1] + l)), t[2] = Math.round(255 * (t[2] + l));
    var c = r[3];
    return void 0 !== c && ("string" == typeof c && (c = c.indexOf("%") > -1 ? parseFloat(c.substring(0, c.length - 1), 10) / 100 : parseFloat(c, 10)), c = Math.floor(255 * c), t[3] = c), {
      format: "hsl",
      value: z(t),
      rgb: t,
      hsl: r,
      alpha: c
    };
  },
  B = function B(e) {
    if (!e || e.length < 3 || e.length > 4) return {
      error: "Not a valid size"
    };
    var t,
      r = q(e[0]),
      n = L(e[1]),
      o = L(e[2]);
    if (o *= 2.55, 0 === n) t = [o = Math.round(o), o, o];else {
      r /= 360, n /= 100;
      var i = Math.floor(6 * r),
        a = 6 * r - i,
        s = Math.round(o * (1 - n)),
        l = Math.round(o * (1 - n * a)),
        c = Math.round(o * (1 - n * (1 - a)));
      o = Math.round(o), t = 0 === (i %= 6) ? [o, c, s] : 1 === i ? [l, o, s] : 2 === i ? [s, o, c] : 3 === i ? [s, l, o] : 4 === i ? [c, s, o] : [o, s, l];
    }
    var u = e[3];
    return void 0 !== u && ("string" == typeof u && (u = u.indexOf("%") > -1 ? parseFloat(u.substring(0, u.length - 1), 10) / 100 : parseFloat(u, 10)), u = Math.floor(255 * u), t[3] = u), {
      format: "hsl",
      value: z(t),
      rgb: t,
      hsv: e,
      alpha: u
    };
  },
  Y = function Y(e) {
    var t = e[0] / 255,
      r = e[1] / 255,
      n = e[2] / 255,
      o = Math.min(t, r, n),
      i = Math.max(t, r, n);
    return {
      cmax: i,
      cmin: o,
      delta: i - o,
      r: t,
      g: r,
      b: n
    };
  },
  J = function J(e) {
    var _Y = Y(e),
      t = _Y.cmin,
      r = _Y.cmax,
      n = _Y.delta,
      o = _Y.r,
      i = _Y.g,
      a = _Y.b,
      s = 0,
      l = 0,
      c = (t + r) / 2;
    0 !== n && (l = n / (1 - Math.abs(2 * c - 1)), l = Math.round(+(100 * l).toFixed(1)), s = r === o ? (i - a) / n % 6 : r === i ? (a - o) / n + 2 : (o - i) / n + 4, (s = Math.round(60 * s)) < 0 && (s += 360));
    var u = [s, l, c = Math.round(c + 100 * c)];
    return 4 === e.length && (u[3] = e[3] / 255), u;
  },
  H = function H(e) {
    var _Y2 = Y(e),
      t = _Y2.cmax,
      r = _Y2.delta,
      n = _Y2.r,
      o = _Y2.g,
      i = _Y2.b;
    if (0 === r) return [0, 0, Math.round(100 * t)];
    var a,
      s = t,
      l = r / t,
      c = (t - n) / r,
      u = (t - o) / r,
      d = (t - i) / r;
    return (a = (a = n === t ? d - u : o === t ? 2 + c - d : 4 + u - c) / 6 % 1) < 0 && (a += 1), [a = Math.round(360 * a), l = Math.round(100 * l), s = Math.round(100 * s)];
  },
  X = function X(e) {
    var t = e.substring(e.indexOf("(") + 1, e.indexOf(")"));
    return t.indexOf(",") > -1 ? t.split(",") : t.indexOf(" ") > -1 ? t.split(" ").filter(function (e) {
      return e.length > 0 && "/" !== e;
    }) : void 0;
  },
  $ = ["plain", "hex", "rgb", "hsl", "hsv"],
  K = [function (e) {
    return {
      format: "plain",
      value: V[e[0]]
    };
  }, function (e) {
    return F(e[0]);
  }, function (e) {
    return U(e);
  }, function (e) {
    return G(e);
  }, function (e) {
    return B(e);
  }],
  Z = [function (e) {
    return {
      format: "plain",
      value: V[e]
    };
  }, function (e) {
    return F(e);
  }, function (e) {
    return U(X(e));
  }, function (e) {
    return G(X(e));
  }],
  Q = [function (e) {
    return void 0 !== V[e];
  }, function (e) {
    return e.startsWith("#");
  }, function (e) {
    return e.startsWith("rgb(") || e.startsWith("rgba(");
  }, function (e) {
    return e.startsWith("hsl(") || e.startsWith("hsla(");
  }],
  ee = function ee(e, t) {
    var _U, _G, _B;
    var r,
      n,
      o,
      i,
      a,
      s,
      l,
      c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      u = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
      d = {
        raw: e
      },
      p = t || "unknown";
    if ("transparent" === e) d.name = e, p = "plain", n = 0;else if ("string" == typeof e) {
      var _Z$f;
      var h = e.trim().toLocaleLowerCase(),
        f = Q.findIndex(function (e) {
          return e(h);
        });
      f > -1 && ((_Z$f = Z[f](h), r = _Z$f.value, p = _Z$f.format, o = _Z$f.rgb, i = _Z$f.hsl, n = _Z$f.alpha, s = _Z$f.error, _Z$f), "plain" === p && (d.name = e), p && (d.css = {
        backgroundColor: e
      }));
    } else if (Number.isInteger(e)) r = e, p = "number";else if (Array.isArray(e) && p) {
      var _K$v;
      var v = $.findIndex(function (e) {
        return e === p;
      });
      v > -1 ? (_K$v = K[v](e), r = _K$v.value, p = _K$v.format, o = _K$v.rgb, i = _K$v.hsl, a = _K$v.hsv, n = _K$v.alpha, s = _K$v.error, _K$v) : s = "unkown format";
    } else e && "r" in e && "g" in e && "b" in e ? (o = [e.r, e.g, e.b], e.a && o.push(e.a), (_U = U(o), r = _U.value, p = _U.format, o = _U.rgb, n = _U.alpha, s = _U.error, _U)) : e && "h" in e && "s" in e && "l" in e ? (i = [e.h, e.s, e.l], e.a && i.push(e.a), (_G = G(i), r = _G.value, p = _G.format, o = _G.rgb, i = _G.hsl, n = _G.alpha, s = _G.error, _G)) : e && "h" in e && "s" in e && "v" in e && (a = [e.h, e.s, e.v], e.a && a.push(e.a), (_B = B(a), r = _B.value, p = _B.format, o = _B.rgb, a = _B.hsv, n = _B.alpha, s = _B.error, _B));
    void 0 === r && (r = 0, n = 0 === n ? n : void 0, d.css = {
      backgroundImage: "\n        linear-gradient(45deg, #ccc 25%, transparent 25%), \n        linear-gradient(135deg, #ccc 25%, transparent 25%),\n        linear-gradient(45deg, transparent 75%, #ccc 75%),\n        linear-gradient(135deg, transparent 75%, #ccc 75%)",
      backgroundSize: "8px 8px",
      backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
      backgroundColor: "white"
    }, "transparent" !== e && (p = "unknown", d.name = "none")), s && (d.error = s), d.value = r, d.alpha = Number.isNaN(n) || void 0 === n ? 1 : n / 255, d.format = p, c || 1 === d.alpha ? 1 === d.alpha && -16777216 === d.value && (l = 255) : l = Math.floor(255 * d.alpha);
    var g = _(r, l);
    return d.hex = g, o = o || W(r), d.rgb = o, d.hsv = a || H(o), d.hsl = i || J(o), d.css || (d.css = {
      backgroundColor: "#".concat(g)
    }), d.name || (d.name = u && Object.keys(V).find(function (e) {
      return V[e] === r;
    }) || "color-".concat(g)), d;
  },
  te = function te(e, t, r) {
    var n;
    return "hex" === t && (n = "#".concat(_(e.value, r || 1 === e.alpha ? void 0 : Math.floor(255 * e.alpha)))), n;
  },
  re = function re(e, t, r, n) {
    var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
      i = e,
      a = !1;
    return e && e.format && e.name ? i.error && r && (i.error = r(i.error)) : (i = e, r && "string" == typeof i && (D && n === I || (I = n, D = {}, Object.keys(V).forEach(function (e) {
      D[r(e)] = e;
    })), a = (i = D[i] || i) !== e), (i = ee(i, null, t, !o)).name && r && (i.translated = r(i.name), a && i.translated && (i.name = i.translated), i.error && (i.error = r(i.error)))), i;
  },
  ne = a([s({
    css: s({}),
    value: l,
    hex: c,
    raw: a([c, u, l, s]),
    name: c,
    alpha: l,
    rgb: d(l),
    hsv: d(l),
    hsl: d(l)
  }), c, l]),
  oe = p(c),
  ie = d(c),
  ae = {
    use: function use() {
      return {
        i18n: {
          language: "us"
        },
        t: function t(e) {
          return e;
        }
      };
    }
  },
  se = function se(e) {
    return e && (ae.use = e), ae.use();
  },
  le = v({
    root: {
      backgroundImage: function backgroundImage(e) {
        return e.colorError || e.alpha < 1 ? "\n    linear-gradient(45deg, #ccc 25%, transparent 25%), \n    linear-gradient(135deg, #ccc 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #ccc 75%),\n    linear-gradient(135deg, transparent 75%, #ccc 75%)" : "none";
      },
      backgroundSize: "8px 8px",
      backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
      backgroundColor: function backgroundColor(e) {
        return e.backgroundColor || "#fff";
      },
      boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
      borderColor: function borderColor(e) {
        return e.borderColor || "#767676";
      },
      borderStyle: "solid",
      borderWidth: function borderWidth(e) {
        return e.borderWidth || 0;
      },
      borderRadius: 4,
      padding: 0,
      width: function width(e) {
        return e.width;
      },
      minWidth: function minWidth(e) {
        return e.minWidth;
      },
      height: function height(e) {
        return e.height;
      },
      "& div": {
        content: '" "',
        background: function background(e) {
          return e.colorError ? "repeating-linear-gradient(\n      135deg,\n      transparent,\n      transparent ".concat(e.width / 2 + 2, "px,\n      #f44336 ").concat(e.width / 2 + 2, "px,\n      #f44336 ").concat(e.width / 2 + 4, "px\n    )") : "none";
        },
        backgroundColor: function backgroundColor(e) {
          return e.colorError ? "transparent" : e.backgroundColor || "#fff";
        },
        width: function width(e) {
          return e.width;
        },
        minWidth: function minWidth(e) {
          return e.minWidth;
        },
        height: function height(e) {
          return e.height;
        },
        border: function border(e) {
          return e.colorError ? "2px solid #f44336" : "".concat(e.borderWidth || 0, "px solid ").concat(e.borderColor || "#767676");
        },
        borderRadius: 4,
        padding: 0
      },
      "&:hover div": {
        backgroundColor: function backgroundColor(e) {
          return e.hoverColor;
        }
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.5)"
      }
    },
    tooltip: {
      width: "min-content"
    }
  }),
  ce = function ce(e) {
    var r = e.color,
      n = e.size,
      o = e.borderWidth,
      i = e.borderColor,
      a = e.forwardRef,
      s = e.tooltip,
      l = e.disableAlpha,
      c = e.className,
      u = T(e, ["color", "size", "borderWidth", "borderColor", "forwardRef", "tooltip", "disableAlpha", "className"]),
      _se = se(),
      d = _se.t,
      p = _se.i18n,
      h = re(r, l, d, p.language),
      f = d(s),
      v = h.css,
      b = h.hsl[2] - 10;
    b < 30 && (b = h.hsl[2] + 50);
    var y = h.alpha,
      x = "hsl(".concat(h.hsl[0], ", ").concat(h.hsl[1], "%, ").concat(b, "%, ").concat(y, ")"),
      w = le(A({
        width: n,
        minWidth: n,
        height: n,
        hoverColor: x,
        borderColor: i,
        borderWidth: o,
        alpha: y,
        colorError: !!h.error
      }, v)),
      k = t.createElement(g, j({
        "data-testid": "colorbutton",
        className: "".concat(w.root, " ").concat(null != c ? c : ""),
        ref: a,
        variant: "contained",
        "aria-label": h.name
      }, u), t.createElement("div", null));
    return s ? t.createElement(m, {
      title: f
    }, t.createElement("div", {
      className: w.tooltip
    }, k)) : k;
  };
ce.propTypes = {
  color: ne.isRequired,
  size: i.number,
  disableAlpha: i.bool,
  borderWidth: i.number,
  borderColor: i.string,
  tooltip: i.string,
  forwardRef: i.shape({
    current: i.elementType
  })
}, ce.defaultProps = {
  size: 24,
  borderWidth: 0,
  borderColor: void 0,
  forwardRef: void 0,
  tooltip: void 0,
  disableAlpha: !1
};
var ue = "undefined" != typeof window ? e.useLayoutEffect : e.useEffect;
function de(t) {
  var r = e.useRef(t);
  return ue(function () {
    r.current = t;
  }), e.useCallback(function () {
    return (0, r.current).apply(void 0, arguments);
  }, []);
}
var pe = v({
    root: {
      position: "absolute",
      width: "inherit",
      height: "inherit",
      background: function background(e) {
        return "".concat(e.cssRgb, " none repeat scroll 0% 0%");
      },
      margin: 0
    },
    gradientPosition: {
      position: "absolute",
      width: "100%",
      height: "100%"
    },
    hsvGradientS: {
      background: "rgba(0, 0, 0, 0) linear-gradient(to right, rgb(255, 255, 255), rgba(255, 255, 255, 0)) repeat scroll 0% 0%"
    },
    hsvGradientV: {
      background: "rgba(0, 0, 0, 0) linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0)) repeat scroll 0% 0%"
    },
    hsvGradientCursor: {
      position: "absolute",
      top: 0,
      left: 0,
      borderColor: "#f0f0f0",
      borderWidth: 1,
      borderStyle: "solid",
      boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
      transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      borderRadius: 4,
      cursor: function cursor(e) {
        return !e.pressed && "pointer";
      },
      zIndex: 100,
      transform: "translate(-4px, -4px)",
      "&:hover": {
        boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
      },
      "&:focus": {
        outline: "none !important",
        boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
      },
      "&:focus > div": {}
    },
    hsvGradientCursorC: {
      width: 8,
      height: 8,
      borderRadius: 4,
      boxShadow: "white 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)"
    }
  }),
  he = function he(e) {
    var r = e.className,
      n = e.color,
      o = e.onChange,
      i = T(e, ["className", "color", "onChange"]),
      a = t.useRef(n),
      _t$useState = t.useState(!1),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      s = _t$useState2[0],
      l = _t$useState2[1],
      _t$useState3 = t.useState(!1),
      _t$useState4 = _slicedToArray(_t$useState3, 2),
      c = _t$useState4[0],
      u = _t$useState4[1];
    t.useEffect(function () {
      a.current = n;
    });
    var d,
      p,
      h,
      f,
      v,
      g,
      m,
      b = t.useRef(),
      y = t.useRef(),
      x = {
        x: 0,
        y: 0
      },
      w = (d = n.hsv[0], p = d / 360, h = 255, f = Math.floor(6 * p), v = 6 * p - f, g = Math.round(h * (1 - v)), m = Math.round(h * v), h = Math.round(h), 0 == (f %= 6) ? [h, m, 0] : 1 === f ? [g, h, 0] : 2 === f ? [0, h, m] : 3 === f ? [0, g, h] : 4 === f ? [m, 0, h] : [h, 0, g]),
      k = "rgb(".concat(w[0], ",").concat(w[1], ",").concat(w[2], ")"),
      E = pe(A(A({}, i), {}, {
        cssRgb: k
      })),
      S = function S(e, t) {
        x = e, y.current.style.top = "".concat(e.y, "px"), y.current.style.left = "".concat(e.x, "px"), t && y.current.focus();
      },
      N = function N(e) {
        if (e) {
          var t = n.hsv;
          x = {
            x: Math.round(t[1] / 100 * (e.clientWidth - 1)),
            y: Math.round((1 - t[2] / 100) * (e.clientHeight - 1))
          }, S(x);
        }
      };
    N(b.current), b.current && (b.current.style.background = "".concat(k, " none repeat scroll 0% 0%"));
    var O = function O(e, t) {
      var r = e.x,
        n = e.y,
        i = t.getBoundingClientRect(),
        s = {
          x: r - i.left,
          y: n - i.top
        };
      s.x < 0 && (s.x = 0), s.y < 0 && (s.y = 0), s.x >= t.clientWidth && (s.x = t.clientWidth - 1), s.y >= t.clientHeight && (s.y = t.clientHeight - 1), S(s, !0);
      var l = s.x / (t.clientWidth - 1) * 100,
        c = 100 * (1 - s.y / (t.clientHeight - 1)),
        u = a.current;
      o([u.hsv[0], l, c]);
    };
    t.useEffect(function () {
      var e = b.current;
      N(e);
      var t = function t(e) {
          l(!0), u(!0), e.preventDefault();
        },
        r = function r(t) {
          var r = {
            x: t.pageX - window.scrollX,
            y: t.pageY - window.scrollY
          };
          O(r, e), u(!1), t.preventDefault();
        },
        n = function n(t) {
          if (c && t.buttons) {
            var r = {
              x: t.pageX - window.scrollX,
              y: t.pageY - window.scrollY
            };
            O(r, e), t.preventDefault();
          }
        },
        o = function o(t) {
          var r = {
            x: t.touches[0].pageX - window.scrollX,
            y: t.touches[0].pageY - window.scrollY
          };
          O(r, e), t.preventDefault();
        };
      return e.addEventListener("mousedown", t), e.addEventListener("mouseup", r), e.addEventListener("mousemove", n), e.addEventListener("touchdown", t), e.addEventListener("touchup", r), e.addEventListener("touchmove", o), function () {
        e.removeEventListener("mousedown", t), e.removeEventListener("mouseup", r), e.removeEventListener("mousemove", n), e.removeEventListener("touchdown", t), e.removeEventListener("touchup", r), e.removeEventListener("touchmove", o);
      };
    }, []);
    var C = de(function (e) {
        if (s) {
          var _x = x,
            t = _x.x,
            r = _x.y;
          switch (e.key) {
            case "ArrowRight":
              t += 1;
              break;
            case "ArrowLeft":
              t -= 1;
              break;
            case "ArrowDown":
              r += 1;
              break;
            case "ArrowUp":
              r -= 1;
              break;
            case "Tab":
              return void l(!1);
            default:
              return;
          }
          e.preventDefault();
          var n = b.current.getBoundingClientRect();
          O({
            x: t + n.left,
            y: r + n.top
          }, b.current);
        }
      }),
      R = de(function (e) {
        l(!0), e.preventDefault();
      }),
      P = de(function (e) {
        l(!1), e.preventDefault();
      });
    return t.createElement("div", {
      className: r
    }, t.createElement("div", j({
      className: E.root
    }, i, {
      ref: b,
      "data-testid": "hsvgradient-color"
    }), t.createElement("div", {
      className: "muicc-hsvgradient-s ".concat(E.hsvGradientS, " ").concat(E.gradientPosition)
    }, t.createElement("div", {
      className: "muicc-hsvgradient-v ".concat(E.hsvGradientV, " ").concat(E.gradientPosition)
    }, t.createElement("div", {
      ref: y,
      tabIndex: "0",
      role: "slider",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": n.hsv[1],
      pressed: "".concat(c),
      "data-testid": "hsvgradient-cursor",
      className: "muicc-hsvgradient-cursor ".concat(E.hsvGradientCursor),
      onKeyDown: C,
      onFocus: R,
      onBlur: P
    }, t.createElement("div", {
      className: "muicc-hsvgradient-cursor-c ".concat(E.hsvGradientCursorC)
    }))))));
  };
he.propTypes = {
  color: ne.isRequired,
  className: i.string.isRequired,
  onChange: i.func.isRequired
};
var fe = {
    black: "#000",
    white: "#fff"
  },
  ve = "#e57373",
  ge = "#f44336",
  me = "#d32f2f",
  be = "#ff4081",
  ye = "#f50057",
  xe = "#c51162",
  we = "#7986cb",
  ke = "#3f51b5",
  Ee = "#303f9f",
  Se = "#64b5f6",
  Ne = "#2196f3",
  Oe = "#1976d2",
  Ce = "#81c784",
  Re = "#4caf50",
  Pe = "#388e3c",
  je = "#ffb74d",
  Me = "#ff9800",
  Ae = "#f57c00",
  Te = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
  };
function De(e, t) {
  return "production" === process.env.NODE_ENV ? function () {
    return null;
  } : function () {
    return e.apply(void 0, arguments) || t.apply(void 0, arguments);
  };
}
function Ie() {
  return (Ie = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }).apply(this, arguments);
}
function Ve(e) {
  return (Ve = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function _e(e) {
  return e && "object" === Ve(e) && e.constructor === Object;
}
function We(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
      clone: !0
    },
    n = r.clone ? Ie({}, e) : e;
  return _e(e) && _e(t) && Object.keys(t).forEach(function (o) {
    "__proto__" !== o && (_e(t[o]) && o in e ? n[o] = We(e[o], t[o], r) : n[o] = t[o]);
  }), n;
}
function ze(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Ue(e) {
  for (var t = "https://material-ui.com/production-error/?code=" + e, r = 1; r < arguments.length; r += 1) {
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  }
  return "Minified Material-UI error #" + e + "; visit " + t + " for the full message.";
}
var Fe = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function qe(e) {
  var t = "".concat(e).match(Fe);
  return t && t[1] || "";
}
function Le(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  return e.displayName || e.name || qe(e) || t;
}
function Ge(e, t, r) {
  var n = Le(t);
  return e.displayName || ("" !== n ? "".concat(r, "(").concat(n, ")") : r);
}
function Be(e) {
  if (null != e) {
    if ("string" == typeof e) return e;
    if ("function" == typeof e) return Le(e, "Component");
    if ("object" === Ve(e)) switch (e.$$typeof) {
      case C:
        return Ge(e, e.render, "ForwardRef");
      case O:
        return Ge(e, e.type, "memo");
      default:
        return;
    }
  }
}
function Ye(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
  return "production" !== process.env.NODE_ENV && (e < t || e > r) && console.error("Material-UI: The value provided ".concat(e, " is out of range [").concat(t, ", ").concat(r, "].")), Math.min(Math.max(t, e), r);
}
function Je(e) {
  if (e.type) return e;
  if ("#" === e.charAt(0)) return Je(function (e) {
    e = e.substr(1);
    var t = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"),
      r = e.match(t);
    return r && 1 === r[0].length && (r = r.map(function (e) {
      return e + e;
    })), r ? "rgb".concat(4 === r.length ? "a" : "", "(").concat(r.map(function (e, t) {
      return t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3;
    }).join(", "), ")") : "";
  }(e));
  var t = e.indexOf("("),
    r = e.substring(0, t);
  if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(r)) throw new Error("production" !== process.env.NODE_ENV ? "Material-UI: Unsupported `".concat(e, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Ue(3, e));
  var n = e.substring(t + 1, e.length - 1).split(",");
  return {
    type: r,
    values: n = n.map(function (e) {
      return parseFloat(e);
    })
  };
}
function He(e) {
  var t = e.type,
    r = e.values;
  return -1 !== t.indexOf("rgb") ? r = r.map(function (e, t) {
    return t < 3 ? parseInt(e, 10) : e;
  }) : -1 !== t.indexOf("hsl") && (r[1] = "".concat(r[1], "%"), r[2] = "".concat(r[2], "%")), "".concat(t, "(").concat(r.join(", "), ")");
}
function Xe(e, t) {
  var r = $e(e),
    n = $e(t);
  return (Math.max(r, n) + .05) / (Math.min(r, n) + .05);
}
function $e(e) {
  var t = "hsl" === (e = Je(e)).type ? Je(function (e) {
    var t = (e = Je(e)).values,
      r = t[0],
      n = t[1] / 100,
      o = t[2] / 100,
      i = n * Math.min(o, 1 - o),
      a = function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + r / 30) % 12;
        return o - i * Math.max(Math.min(t - 3, 9 - t, 1), -1);
      },
      s = "rgb",
      l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
    return "hsla" === e.type && (s += "a", l.push(t[3])), He({
      type: s,
      values: l
    });
  }(e)).values : e.values;
  return t = t.map(function (e) {
    return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
  }), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3));
}
function Ke(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = {},
    i = Object.keys(e);
  for (n = 0; n < i.length; n++) {
    r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
  }
  return o;
}
function Ze(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = Ke(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }
  return o;
}
var Qe = ["xs", "sm", "md", "lg", "xl"];
function et(e) {
  var t = e.values,
    r = void 0 === t ? {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    } : t,
    n = e.unit,
    o = void 0 === n ? "px" : n,
    i = e.step,
    a = void 0 === i ? 5 : i,
    s = Ze(e, ["values", "unit", "step"]);
  function l(e) {
    var t = "number" == typeof r[e] ? r[e] : e;
    return "@media (min-width:".concat(t).concat(o, ")");
  }
  function c(e, t) {
    var n = Qe.indexOf(t);
    return n === Qe.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof r[e] ? r[e] : e).concat(o, ") and ") + "(max-width:".concat((-1 !== n && "number" == typeof r[Qe[n + 1]] ? r[Qe[n + 1]] : t) - a / 100).concat(o, ")");
  }
  return Ie({
    keys: Qe,
    values: r,
    up: l,
    down: function down(e) {
      var t = Qe.indexOf(e) + 1,
        n = r[Qe[t]];
      return t === Qe.length ? l("xs") : "@media (max-width:".concat(("number" == typeof n && t > 0 ? n : e) - a / 100).concat(o, ")");
    },
    between: c,
    only: function only(e) {
      return c(e, e);
    },
    width: function width(e) {
      return r[e];
    }
  }, s);
}
function tt(e, t, r) {
  var n;
  return Ie({
    gutters: function gutters() {
      var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return Ie({
        paddingLeft: t(2),
        paddingRight: t(2)
      }, r, ze({}, e.up("sm"), Ie({
        paddingLeft: t(3),
        paddingRight: t(3)
      }, r[e.up("sm")])));
    },
    toolbar: (n = {
      minHeight: 56
    }, ze(n, "".concat(e.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), ze(n, e.up("sm"), {
      minHeight: 64
    }), n)
  }, r);
}
var rt = {
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)"
    },
    divider: "rgba(0, 0, 0, 0.12)",
    background: {
      paper: fe.white,
      default: Te[50]
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: .04,
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: .08,
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: .38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: .12,
      activatedOpacity: .12
    }
  },
  nt = {
    text: {
      primary: fe.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      hint: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: Te[800],
      default: "#303030"
    },
    action: {
      active: fe.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: .08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: .16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: .38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: .12,
      activatedOpacity: .24
    }
  };
function ot(e, t, r, n) {
  var o = n.light || n,
    i = n.dark || 1.5 * n;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : "light" === t ? e.light = function (e, t) {
    if (e = Je(e), t = Ye(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t;else if (-1 !== e.type.indexOf("rgb")) for (var r = 0; r < 3; r += 1) {
      e.values[r] += (255 - e.values[r]) * t;
    }
    return He(e);
  }(e.main, o) : "dark" === t && (e.dark = function (e, t) {
    if (e = Je(e), t = Ye(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t;else if (-1 !== e.type.indexOf("rgb")) for (var r = 0; r < 3; r += 1) {
      e.values[r] *= 1 - t;
    }
    return He(e);
  }(e.main, i)));
}
function it(e) {
  var t = e.primary,
    r = void 0 === t ? {
      light: we,
      main: ke,
      dark: Ee
    } : t,
    n = e.secondary,
    o = void 0 === n ? {
      light: be,
      main: ye,
      dark: xe
    } : n,
    i = e.error,
    a = void 0 === i ? {
      light: ve,
      main: ge,
      dark: me
    } : i,
    s = e.warning,
    l = void 0 === s ? {
      light: je,
      main: Me,
      dark: Ae
    } : s,
    c = e.info,
    u = void 0 === c ? {
      light: Se,
      main: Ne,
      dark: Oe
    } : c,
    d = e.success,
    p = void 0 === d ? {
      light: Ce,
      main: Re,
      dark: Pe
    } : d,
    h = e.type,
    f = void 0 === h ? "light" : h,
    v = e.contrastThreshold,
    g = void 0 === v ? 3 : v,
    m = e.tonalOffset,
    b = void 0 === m ? .2 : m,
    y = Ze(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function x(e) {
    var t = Xe(e, nt.text.primary) >= g ? nt.text.primary : rt.text.primary;
    if ("production" !== process.env.NODE_ENV) {
      var r = Xe(e, t);
      r < 3 && console.error(["Material-UI: The contrast ratio of ".concat(r, ":1 for ").concat(t, " on ").concat(e), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
    }
    return t;
  }
  var w = function w(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
      if (!(e = Ie({}, e)).main && e[t] && (e.main = e[t]), !e.main) throw new Error("production" !== process.env.NODE_ENV ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(t, "` property.") : Ue(4, t));
      if ("string" != typeof e.main) throw new Error("production" !== process.env.NODE_ENV ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(e.main), '` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport { green } from "@material-ui/core/colors";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });') : Ue(5, JSON.stringify(e.main)));
      return ot(e, "light", r, b), ot(e, "dark", n, b), e.contrastText || (e.contrastText = x(e.main)), e;
    },
    k = {
      dark: nt,
      light: rt
    };
  return "production" !== process.env.NODE_ENV && (k[f] || console.error("Material-UI: The palette type `".concat(f, "` is not supported."))), We(Ie({
    common: fe,
    type: f,
    primary: w(r),
    secondary: w(o, "A400", "A200", "A700"),
    error: w(a),
    warning: w(l),
    info: w(u),
    success: w(p),
    grey: Te,
    contrastThreshold: g,
    getContrastText: x,
    augmentColor: w,
    tonalOffset: b
  }, k[f]), y);
}
function at(e) {
  return Math.round(1e5 * e) / 1e5;
}
var st = {
  textTransform: "uppercase"
};
function lt(e, t) {
  var r = "function" == typeof t ? t(e) : t,
    n = r.fontFamily,
    o = void 0 === n ? '"Roboto", "Helvetica", "Arial", sans-serif' : n,
    i = r.fontSize,
    a = void 0 === i ? 14 : i,
    s = r.fontWeightLight,
    l = void 0 === s ? 300 : s,
    c = r.fontWeightRegular,
    u = void 0 === c ? 400 : c,
    d = r.fontWeightMedium,
    p = void 0 === d ? 500 : d,
    h = r.fontWeightBold,
    f = void 0 === h ? 700 : h,
    v = r.htmlFontSize,
    g = void 0 === v ? 16 : v,
    m = r.allVariants,
    b = r.pxToRem,
    y = Ze(r, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  "production" !== process.env.NODE_ENV && ("number" != typeof a && console.error("Material-UI: `fontSize` is required to be a number."), "number" != typeof g && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var x = a / 14,
    w = b || function (e) {
      return "".concat(e / g * x, "rem");
    },
    k = function k(e, t, r, n, i) {
      return Ie({
        fontFamily: o,
        fontWeight: e,
        fontSize: w(t),
        lineHeight: r
      }, '"Roboto", "Helvetica", "Arial", sans-serif' === o ? {
        letterSpacing: "".concat(at(n / t), "em")
      } : {}, i, m);
    },
    E = {
      h1: k(l, 96, 1.167, -1.5),
      h2: k(l, 60, 1.2, -.5),
      h3: k(u, 48, 1.167, 0),
      h4: k(u, 34, 1.235, .25),
      h5: k(u, 24, 1.334, 0),
      h6: k(p, 20, 1.6, .15),
      subtitle1: k(u, 16, 1.75, .15),
      subtitle2: k(p, 14, 1.57, .1),
      body1: k(u, 16, 1.5, .15),
      body2: k(u, 14, 1.43, .15),
      button: k(p, 14, 1.75, .4, st),
      caption: k(u, 12, 1.66, .4),
      overline: k(u, 12, 2.66, 1, st)
    };
  return We(Ie({
    htmlFontSize: g,
    pxToRem: w,
    round: at,
    fontFamily: o,
    fontSize: a,
    fontWeightLight: l,
    fontWeightRegular: u,
    fontWeightMedium: p,
    fontWeightBold: f
  }, E), y, {
    clone: !1
  });
}
function ct() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",");
}
var ut = ["none", ct(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ct(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ct(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ct(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ct(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ct(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ct(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ct(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ct(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ct(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ct(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ct(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ct(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ct(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ct(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ct(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ct(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ct(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ct(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ct(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ct(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ct(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ct(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ct(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
  dt = {
    borderRadius: 4
  },
  pt = "production" !== process.env.NODE_ENV ? i.oneOfType([i.number, i.string, i.object, i.array]) : {};
function ht(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
function ft(e) {
  return function (e) {
    if (Array.isArray(e)) return ht(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return ht(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ht(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var vt;
function gt(e) {
  var t = e.spacing || 8;
  return "number" == typeof t ? function (e) {
    return "production" !== process.env.NODE_ENV && "number" != typeof e && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(e, ".")), t * e;
  } : Array.isArray(t) ? function (e) {
    return "production" !== process.env.NODE_ENV && e > t.length - 1 && console.error(["Material-UI: The value provided (".concat(e, ") overflows."), "The supported values are: ".concat(JSON.stringify(t), "."), "".concat(e, " > ").concat(t.length - 1, ", you need to add the missing values.")].join("\n")), t[e];
  } : "function" == typeof t ? t : ("production" !== process.env.NODE_ENV && console.error(["Material-UI: The `theme.spacing` value (".concat(t, ") is invalid."), "It should be a number, an array or a function."].join("\n")), function () {});
}
function mt() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
  if (e.mui) return e;
  var t = gt({
      spacing: e
    }),
    r = function r() {
      for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
        r[n] = arguments[n];
      }
      return "production" !== process.env.NODE_ENV && (r.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(r.length))), 0 === r.length ? t(1) : 1 === r.length ? t(r[0]) : r.map(function (e) {
        if ("string" == typeof e) return e;
        var r = t(e);
        return "number" == typeof r ? "".concat(r, "px") : r;
      }).join(" ");
    };
  return Object.defineProperty(r, "unit", {
    get: function get() {
      return "production" !== process.env.NODE_ENV && (vt && "test" !== process.env.NODE_ENV || console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join("\n")), vt = !0), e;
    }
  }), r.mui = !0, r;
}
"production" === process.env.NODE_ENV || ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"].reduce(function (e, t) {
  return e[t] = pt, e;
}, {});
var bt = {
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
  },
  yt = {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195
  };
function xt(e) {
  return "".concat(Math.round(e), "ms");
}
var wt = {
    easing: bt,
    duration: yt,
    create: function create() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.duration,
        n = void 0 === r ? yt.standard : r,
        o = t.easing,
        i = void 0 === o ? bt.easeInOut : o,
        a = t.delay,
        s = void 0 === a ? 0 : a,
        l = Ze(t, ["duration", "easing", "delay"]);
      if ("production" !== process.env.NODE_ENV) {
        var c = function c(e) {
            return "string" == typeof e;
          },
          u = function u(e) {
            return !isNaN(parseFloat(e));
          };
        c(e) || Array.isArray(e) || console.error('Material-UI: Argument "props" must be a string or Array.'), u(n) || c(n) || console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(n, ".")), c(i) || console.error('Material-UI: Argument "easing" must be a string.'), u(s) || c(s) || console.error('Material-UI: Argument "delay" must be a number or a string.'), 0 !== Object.keys(l).length && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(l).join(","), "]."));
      }
      return (Array.isArray(e) ? e : [e]).map(function (e) {
        return "".concat(e, " ").concat("string" == typeof n ? n : xt(n), " ").concat(i, " ").concat("string" == typeof s ? s : xt(s));
      }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(e) {
      if (!e) return 0;
      var t = e / 36;
      return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5));
    }
  },
  kt = {
    mobileStepper: 1e3,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  };
var Et = "function" == typeof Symbol && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__",
  St = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function Nt(e) {
  var t = e.theme,
    r = e.name,
    n = e.props;
  if (!t || !t.props || !t.props[r]) return n;
  var o,
    i = t.props[r];
  for (o in i) {
    void 0 === n[o] && (n[o] = i[o]);
  }
  return n;
}
var Ot = "production" === process.env.NODE_ENV;
function Ct(e, t) {
  if (!Ot) {
    if (e) return;
    var r = "Warning: " + t;
    "undefined" != typeof console && console.warn(r);
    try {
      throw Error(r);
    } catch (e) {}
  }
}
var Rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  Pt = "object" === ("undefined" == typeof window ? "undefined" : Rt(window)) && "object" === ("undefined" == typeof document ? "undefined" : Rt(document)) && 9 === document.nodeType;
function jt(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Mt(e, t, r) {
  return t && jt(e.prototype, t), r && jt(e, r), e;
}
function At(e, t) {
  return (At = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function Tt(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, At(e, t);
}
function Dt(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var It = {}.constructor;
function Vt(e) {
  if (null == e || "object" != typeof e) return e;
  if (Array.isArray(e)) return e.map(Vt);
  if (e.constructor !== It) return e;
  var t = {};
  for (var r in e) {
    t[r] = Vt(e[r]);
  }
  return t;
}
function _t(e, t, r) {
  void 0 === e && (e = "unnamed");
  var n = r.jss,
    o = Vt(t),
    i = n.plugins.onCreateRule(e, o, r);
  return i || ("@" === e[0] && "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] Unknown rule " + e), null);
}
var Wt = function Wt(e, t) {
    for (var r = "", n = 0; n < e.length && "!important" !== e[n]; n++) {
      r && (r += t), r += e[n];
    }
    return r;
  },
  zt = function zt(e, t) {
    if (void 0 === t && (t = !1), !Array.isArray(e)) return e;
    var r = "";
    if (Array.isArray(e[0])) for (var n = 0; n < e.length && "!important" !== e[n]; n++) {
      r && (r += ", "), r += Wt(e[n], " ");
    } else r = Wt(e, ", ");
    return t || "!important" !== e[e.length - 1] || (r += " !important"), r;
  };
function Ut(e, t) {
  for (var r = "", n = 0; n < t; n++) {
    r += "  ";
  }
  return r + e;
}
function Ft(e, t, r) {
  void 0 === r && (r = {});
  var n = "";
  if (!t) return n;
  var o = r.indent,
    i = void 0 === o ? 0 : o,
    a = t.fallbacks;
  if (e && i++, a) if (Array.isArray(a)) for (var s = 0; s < a.length; s++) {
    var l = a[s];
    for (var c in l) {
      var u = l[c];
      null != u && (n && (n += "\n"), n += "" + Ut(c + ": " + zt(u) + ";", i));
    }
  } else for (var d in a) {
    var p = a[d];
    null != p && (n && (n += "\n"), n += "" + Ut(d + ": " + zt(p) + ";", i));
  }
  for (var h in t) {
    var f = t[h];
    null != f && "fallbacks" !== h && (n && (n += "\n"), n += "" + Ut(h + ": " + zt(f) + ";", i));
  }
  return (n || r.allowEmpty) && e ? (n && (n = "\n" + n + "\n"), Ut(e + " {" + n, --i) + Ut("}", i)) : n;
}
var qt = /([[\].#*$><+~=|^:(),"'`\s])/g,
  Lt = "undefined" != typeof CSS && CSS.escape,
  Gt = function Gt(e) {
    return Lt ? Lt(e) : e.replace(qt, "\\$1");
  },
  Bt = function () {
    function e(e, t, r) {
      this.type = "style", this.key = void 0, this.isProcessed = !1, this.style = void 0, this.renderer = void 0, this.renderable = void 0, this.options = void 0;
      var n = r.sheet,
        o = r.Renderer;
      this.key = e, this.options = r, this.style = t, n ? this.renderer = n.renderer : o && (this.renderer = new o());
    }
    return e.prototype.prop = function (e, t, r) {
      if (void 0 === t) return this.style[e];
      var n = !!r && r.force;
      if (!n && this.style[e] === t) return this;
      var o = t;
      r && !1 === r.process || (o = this.options.jss.plugins.onChangeValue(t, e, this));
      var i = null == o || !1 === o,
        a = (e in this.style);
      if (i && !a && !n) return this;
      var s = i && a;
      if (s ? delete this.style[e] : this.style[e] = o, this.renderable && this.renderer) return s ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, o), this;
      var l = this.options.sheet;
      return l && l.attached && "production" !== process.env.NODE_ENV && Ct(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
    }, e;
  }(),
  Yt = function (e) {
    function t(t, r, n) {
      var o;
      (o = e.call(this, t, r, n) || this).selectorText = void 0, o.id = void 0, o.renderable = void 0;
      var i = n.selector,
        a = n.scoped,
        s = n.sheet,
        l = n.generateId;
      return i ? o.selectorText = i : !1 !== a && (o.id = l(Dt(Dt(o)), s), o.selectorText = "." + Gt(o.id)), o;
    }
    Tt(t, e);
    var r = t.prototype;
    return r.applyTo = function (e) {
      var t = this.renderer;
      if (t) {
        var r = this.toJSON();
        for (var n in r) {
          t.setProperty(e, n, r[n]);
        }
      }
      return this;
    }, r.toJSON = function () {
      var e = {};
      for (var t in this.style) {
        var r = this.style[t];
        "object" != typeof r ? e[t] = r : Array.isArray(r) && (e[t] = zt(r));
      }
      return e;
    }, r.toString = function (e) {
      var t = this.options.sheet,
        r = !!t && t.options.link ? Ie({}, e, {
          allowEmpty: !0
        }) : e;
      return Ft(this.selectorText, this.style, r);
    }, Mt(t, [{
      key: "selector",
      set: function set(e) {
        if (e !== this.selectorText) {
          this.selectorText = e;
          var t = this.renderer,
            r = this.renderable;
          if (r && t) t.setSelector(r, e) || t.replaceRule(r, this);
        }
      },
      get: function get() {
        return this.selectorText;
      }
    }]), t;
  }(Bt),
  Jt = {
    onCreateRule: function onCreateRule(e, t, r) {
      return "@" === e[0] || r.parent && "keyframes" === r.parent.type ? null : new Yt(e, t, r);
    }
  },
  Ht = {
    indent: 1,
    children: !0
  },
  Xt = /@([\w-]+)/,
  $t = function () {
    function e(e, t, r) {
      this.type = "conditional", this.at = void 0, this.key = void 0, this.query = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e;
      var n = e.match(Xt);
      for (var o in this.at = n ? n[1] : "unknown", this.query = r.name || "@" + this.at, this.options = r, this.rules = new yr(Ie({}, r, {
        parent: this
      })), t) {
        this.rules.add(o, t[o]);
      }
      this.rules.process();
    }
    var t = e.prototype;
    return t.getRule = function (e) {
      return this.rules.get(e);
    }, t.indexOf = function (e) {
      return this.rules.indexOf(e);
    }, t.addRule = function (e, t, r) {
      var n = this.rules.add(e, t, r);
      return n ? (this.options.jss.plugins.onProcessRule(n), n) : null;
    }, t.toString = function (e) {
      if (void 0 === e && (e = Ht), null == e.indent && (e.indent = Ht.indent), null == e.children && (e.children = Ht.children), !1 === e.children) return this.query + " {}";
      var t = this.rules.toString(e);
      return t ? this.query + " {\n" + t + "\n}" : "";
    }, e;
  }(),
  Kt = /@media|@supports\s+/,
  Zt = {
    onCreateRule: function onCreateRule(e, t, r) {
      return Kt.test(e) ? new $t(e, t, r) : null;
    }
  },
  Qt = {
    indent: 1,
    children: !0
  },
  er = /@keyframes\s+([\w-]+)/,
  tr = function () {
    function e(e, t, r) {
      this.type = "keyframes", this.at = "@keyframes", this.key = void 0, this.name = void 0, this.id = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0;
      var n = e.match(er);
      n && n[1] ? this.name = n[1] : (this.name = "noname", "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] Bad keyframes name " + e)), this.key = this.type + "-" + this.name, this.options = r;
      var o = r.scoped,
        i = r.sheet,
        a = r.generateId;
      for (var s in this.id = !1 === o ? this.name : Gt(a(this, i)), this.rules = new yr(Ie({}, r, {
        parent: this
      })), t) {
        this.rules.add(s, t[s], Ie({}, r, {
          parent: this
        }));
      }
      this.rules.process();
    }
    return e.prototype.toString = function (e) {
      if (void 0 === e && (e = Qt), null == e.indent && (e.indent = Qt.indent), null == e.children && (e.children = Qt.children), !1 === e.children) return this.at + " " + this.id + " {}";
      var t = this.rules.toString(e);
      return t && (t = "\n" + t + "\n"), this.at + " " + this.id + " {" + t + "}";
    }, e;
  }(),
  rr = /@keyframes\s+/,
  nr = /\$([\w-]+)/g,
  or = function or(e, t) {
    return "string" == typeof e ? e.replace(nr, function (e, r) {
      return r in t ? t[r] : ("production" !== process.env.NODE_ENV && Ct(!1, '[JSS] Referenced keyframes rule "' + r + '" is not defined.'), e);
    }) : e;
  },
  ir = function ir(e, t, r) {
    var n = e[t],
      o = or(n, r);
    o !== n && (e[t] = o);
  },
  ar = {
    onCreateRule: function onCreateRule(e, t, r) {
      return "string" == typeof e && rr.test(e) ? new tr(e, t, r) : null;
    },
    onProcessStyle: function onProcessStyle(e, t, r) {
      return "style" === t.type && r ? ("animation-name" in e && ir(e, "animation-name", r.keyframes), "animation" in e && ir(e, "animation", r.keyframes), e) : e;
    },
    onChangeValue: function onChangeValue(e, t, r) {
      var n = r.options.sheet;
      if (!n) return e;
      switch (t) {
        case "animation":
        case "animation-name":
          return or(e, n.keyframes);
        default:
          return e;
      }
    }
  },
  sr = function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
        n[o] = arguments[o];
      }
      return (t = e.call.apply(e, [this].concat(n)) || this).renderable = void 0, t;
    }
    return Tt(t, e), t.prototype.toString = function (e) {
      var t = this.options.sheet,
        r = !!t && t.options.link ? Ie({}, e, {
          allowEmpty: !0
        }) : e;
      return Ft(this.key, this.style, r);
    }, t;
  }(Bt),
  lr = {
    onCreateRule: function onCreateRule(e, t, r) {
      return r.parent && "keyframes" === r.parent.type ? new sr(e, t, r) : null;
    }
  },
  cr = function () {
    function e(e, t, r) {
      this.type = "font-face", this.at = "@font-face", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = r;
    }
    return e.prototype.toString = function (e) {
      if (Array.isArray(this.style)) {
        for (var t = "", r = 0; r < this.style.length; r++) {
          t += Ft(this.at, this.style[r]), this.style[r + 1] && (t += "\n");
        }
        return t;
      }
      return Ft(this.at, this.style, e);
    }, e;
  }(),
  ur = /@font-face/,
  dr = {
    onCreateRule: function onCreateRule(e, t, r) {
      return ur.test(e) ? new cr(e, t, r) : null;
    }
  },
  pr = function () {
    function e(e, t, r) {
      this.type = "viewport", this.at = "@viewport", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = r;
    }
    return e.prototype.toString = function (e) {
      return Ft(this.key, this.style, e);
    }, e;
  }(),
  hr = {
    onCreateRule: function onCreateRule(e, t, r) {
      return "@viewport" === e || "@-ms-viewport" === e ? new pr(e, t, r) : null;
    }
  },
  fr = function () {
    function e(e, t, r) {
      this.type = "simple", this.key = void 0, this.value = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.value = t, this.options = r;
    }
    return e.prototype.toString = function (e) {
      if (Array.isArray(this.value)) {
        for (var t = "", r = 0; r < this.value.length; r++) {
          t += this.key + " " + this.value[r] + ";", this.value[r + 1] && (t += "\n");
        }
        return t;
      }
      return this.key + " " + this.value + ";";
    }, e;
  }(),
  vr = {
    "@charset": !0,
    "@import": !0,
    "@namespace": !0
  },
  gr = [Jt, Zt, ar, lr, dr, hr, {
    onCreateRule: function onCreateRule(e, t, r) {
      return e in vr ? new fr(e, t, r) : null;
    }
  }],
  mr = {
    process: !0
  },
  br = {
    force: !0,
    process: !0
  },
  yr = function () {
    function e(e) {
      this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = void 0, this.classes = void 0, this.keyframes = void 0, this.options = e, this.classes = e.classes, this.keyframes = e.keyframes;
    }
    var t = e.prototype;
    return t.add = function (e, t, r) {
      var n = this.options,
        o = n.parent,
        i = n.sheet,
        a = n.jss,
        s = n.Renderer,
        l = n.generateId,
        c = n.scoped,
        u = Ie({
          classes: this.classes,
          parent: o,
          sheet: i,
          jss: a,
          Renderer: s,
          generateId: l,
          scoped: c,
          name: e,
          keyframes: this.keyframes,
          selector: void 0
        }, r),
        d = e;
      e in this.raw && (d = e + "-d" + this.counter++), this.raw[d] = t, d in this.classes && (u.selector = "." + Gt(this.classes[d]));
      var p = _t(d, t, u);
      if (!p) return null;
      this.register(p);
      var h = void 0 === u.index ? this.index.length : u.index;
      return this.index.splice(h, 0, p), p;
    }, t.get = function (e) {
      return this.map[e];
    }, t.remove = function (e) {
      this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1);
    }, t.indexOf = function (e) {
      return this.index.indexOf(e);
    }, t.process = function () {
      var e = this.options.jss.plugins;
      this.index.slice(0).forEach(e.onProcessRule, e);
    }, t.register = function (e) {
      this.map[e.key] = e, e instanceof Yt ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof tr && this.keyframes && (this.keyframes[e.name] = e.id);
    }, t.unregister = function (e) {
      delete this.map[e.key], e instanceof Yt ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof tr && delete this.keyframes[e.name];
    }, t.update = function () {
      var e, t, r;
      if ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (e = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1], r = arguments.length <= 2 ? void 0 : arguments[2]) : (t = arguments.length <= 0 ? void 0 : arguments[0], r = arguments.length <= 1 ? void 0 : arguments[1], e = null), e) this.updateOne(this.map[e], t, r);else for (var n = 0; n < this.index.length; n++) {
        this.updateOne(this.index[n], t, r);
      }
    }, t.updateOne = function (t, r, n) {
      void 0 === n && (n = mr);
      var o = this.options,
        i = o.jss.plugins,
        a = o.sheet;
      if (t.rules instanceof e) t.rules.update(r, n);else {
        var s = t,
          l = s.style;
        if (i.onUpdate(r, t, a, n), n.process && l && l !== s.style) {
          for (var c in i.onProcessStyle(s.style, s, a), s.style) {
            var u = s.style[c];
            u !== l[c] && s.prop(c, u, br);
          }
          for (var d in l) {
            var p = s.style[d],
              h = l[d];
            null == p && p !== h && s.prop(d, null, br);
          }
        }
      }
    }, t.toString = function (e) {
      for (var t = "", r = this.options.sheet, n = !!r && r.options.link, o = 0; o < this.index.length; o++) {
        var i = this.index[o].toString(e);
        (i || n) && (t && (t += "\n"), t += i);
      }
      return t;
    }, e;
  }(),
  xr = function () {
    function e(e, t) {
      for (var r in this.options = void 0, this.deployed = void 0, this.attached = void 0, this.rules = void 0, this.renderer = void 0, this.classes = void 0, this.keyframes = void 0, this.queue = void 0, this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = Ie({}, t, {
        sheet: this,
        parent: this,
        classes: this.classes,
        keyframes: this.keyframes
      }), t.Renderer && (this.renderer = new t.Renderer(this)), this.rules = new yr(this.options), e) {
        this.rules.add(r, e[r]);
      }
      this.rules.process();
    }
    var t = e.prototype;
    return t.attach = function () {
      return this.attached || (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy()), this;
    }, t.detach = function () {
      return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
    }, t.addRule = function (e, t, r) {
      var n = this.queue;
      this.attached && !n && (this.queue = []);
      var o = this.rules.add(e, t, r);
      return o ? (this.options.jss.plugins.onProcessRule(o), this.attached ? this.deployed ? (n ? n.push(o) : (this.insertRule(o), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0)), o) : o : (this.deployed = !1, o)) : null;
    }, t.insertRule = function (e) {
      this.renderer && this.renderer.insertRule(e);
    }, t.addRules = function (e, t) {
      var r = [];
      for (var n in e) {
        var o = this.addRule(n, e[n], t);
        o && r.push(o);
      }
      return r;
    }, t.getRule = function (e) {
      return this.rules.get(e);
    }, t.deleteRule = function (e) {
      var t = "object" == typeof e ? e : this.rules.get(e);
      return !(!t || this.attached && !t.renderable) && (this.rules.remove(t), !(this.attached && t.renderable && this.renderer) || this.renderer.deleteRule(t.renderable));
    }, t.indexOf = function (e) {
      return this.rules.indexOf(e);
    }, t.deploy = function () {
      return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
    }, t.update = function () {
      var e;
      return (e = this.rules).update.apply(e, arguments), this;
    }, t.updateOne = function (e, t, r) {
      return this.rules.updateOne(e, t, r), this;
    }, t.toString = function (e) {
      return this.rules.toString(e);
    }, e;
  }(),
  wr = function () {
    function e() {
      this.plugins = {
        internal: [],
        external: []
      }, this.registry = void 0;
    }
    var t = e.prototype;
    return t.onCreateRule = function (e, t, r) {
      for (var n = 0; n < this.registry.onCreateRule.length; n++) {
        var o = this.registry.onCreateRule[n](e, t, r);
        if (o) return o;
      }
      return null;
    }, t.onProcessRule = function (e) {
      if (!e.isProcessed) {
        for (var t = e.options.sheet, r = 0; r < this.registry.onProcessRule.length; r++) {
          this.registry.onProcessRule[r](e, t);
        }
        e.style && this.onProcessStyle(e.style, e, t), e.isProcessed = !0;
      }
    }, t.onProcessStyle = function (e, t, r) {
      for (var n = 0; n < this.registry.onProcessStyle.length; n++) {
        t.style = this.registry.onProcessStyle[n](t.style, t, r);
      }
    }, t.onProcessSheet = function (e) {
      for (var t = 0; t < this.registry.onProcessSheet.length; t++) {
        this.registry.onProcessSheet[t](e);
      }
    }, t.onUpdate = function (e, t, r, n) {
      for (var o = 0; o < this.registry.onUpdate.length; o++) {
        this.registry.onUpdate[o](e, t, r, n);
      }
    }, t.onChangeValue = function (e, t, r) {
      for (var n = e, o = 0; o < this.registry.onChangeValue.length; o++) {
        n = this.registry.onChangeValue[o](n, t, r);
      }
      return n;
    }, t.use = function (e, t) {
      void 0 === t && (t = {
        queue: "external"
      });
      var r = this.plugins[t.queue];
      -1 === r.indexOf(e) && (r.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (e, t) {
        for (var r in t) {
          r in e ? e[r].push(t[r]) : "production" !== process.env.NODE_ENV && Ct(!1, '[JSS] Unknown hook "' + r + '".');
        }
        return e;
      }, {
        onCreateRule: [],
        onProcessRule: [],
        onProcessStyle: [],
        onProcessSheet: [],
        onChangeValue: [],
        onUpdate: []
      }));
    }, e;
  }(),
  kr = new (function () {
    function e() {
      this.registry = [];
    }
    var t = e.prototype;
    return t.add = function (e) {
      var t = this.registry,
        r = e.options.index;
      if (-1 === t.indexOf(e)) if (0 === t.length || r >= this.index) t.push(e);else for (var n = 0; n < t.length; n++) {
        if (t[n].options.index > r) return void t.splice(n, 0, e);
      }
    }, t.reset = function () {
      this.registry = [];
    }, t.remove = function (e) {
      var t = this.registry.indexOf(e);
      this.registry.splice(t, 1);
    }, t.toString = function (e) {
      for (var t = void 0 === e ? {} : e, r = t.attached, n = Ke(t, ["attached"]), o = "", i = 0; i < this.registry.length; i++) {
        var a = this.registry[i];
        null != r && a.attached !== r || (o && (o += "\n"), o += a.toString(n));
      }
      return o;
    }, Mt(e, [{
      key: "index",
      get: function get() {
        return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index;
      }
    }]), e;
  }())(),
  Er = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window && window.Math === Math ? window : "undefined" != typeof self && self.Math === Math ? self : Function("return this")(),
  Sr = "2f1acc6c3a606b082e5eef5e54414ffb";
null == Er[Sr] && (Er[Sr] = 0);
var Nr = Er[Sr]++,
  Or = function Or(e) {
    void 0 === e && (e = {});
    var t = 0;
    return function (r, n) {
      (t += 1) > 1e10 && "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] You might have a memory leak. Rule counter is at " + t + ".");
      var o = "",
        i = "";
      return n && (n.options.classNamePrefix && (i = n.options.classNamePrefix), null != n.options.jss.id && (o = String(n.options.jss.id))), e.minify ? "" + (i || "c") + Nr + o + t : i + r.key + "-" + Nr + (o ? "-" + o : "") + "-" + t;
    };
  },
  Cr = function Cr(e) {
    var t;
    return function () {
      return t || (t = e()), t;
    };
  },
  Rr = function Rr(e, t) {
    try {
      return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t);
    } catch (e) {
      return "";
    }
  },
  Pr = function Pr(e, t, r) {
    try {
      var n = r;
      if (Array.isArray(r) && (n = zt(r, !0), "!important" === r[r.length - 1])) return e.style.setProperty(t, n, "important"), !0;
      e.attributeStyleMap ? e.attributeStyleMap.set(t, n) : e.style.setProperty(t, n);
    } catch (e) {
      return !1;
    }
    return !0;
  },
  jr = function jr(e, t) {
    try {
      e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t);
    } catch (e) {
      "production" !== process.env.NODE_ENV && Ct(!1, '[JSS] DOMException "' + e.message + '" was thrown. Tried to remove property "' + t + '".');
    }
  },
  Mr = function Mr(e, t) {
    return e.selectorText = t, e.selectorText === t;
  },
  Ar = Cr(function () {
    return document.querySelector("head");
  });
function Tr(e) {
  var t = kr.registry;
  if (t.length > 0) {
    var r = function (e, t) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        if (n.attached && n.options.index > t.index && n.options.insertionPoint === t.insertionPoint) return n;
      }
      return null;
    }(t, e);
    if (r && r.renderer) return {
      parent: r.renderer.element.parentNode,
      node: r.renderer.element
    };
    if ((r = function (e, t) {
      for (var r = e.length - 1; r >= 0; r--) {
        var n = e[r];
        if (n.attached && n.options.insertionPoint === t.insertionPoint) return n;
      }
      return null;
    }(t, e)) && r.renderer) return {
      parent: r.renderer.element.parentNode,
      node: r.renderer.element.nextSibling
    };
  }
  var n = e.insertionPoint;
  if (n && "string" == typeof n) {
    var o = function (e) {
      for (var t = Ar(), r = 0; r < t.childNodes.length; r++) {
        var n = t.childNodes[r];
        if (8 === n.nodeType && n.nodeValue.trim() === e) return n;
      }
      return null;
    }(n);
    if (o) return {
      parent: o.parentNode,
      node: o.nextSibling
    };
    "production" !== process.env.NODE_ENV && Ct(!1, '[JSS] Insertion point "' + n + '" not found.');
  }
  return !1;
}
var Dr = Cr(function () {
    var e = document.querySelector('meta[property="csp-nonce"]');
    return e ? e.getAttribute("content") : null;
  }),
  Ir = function Ir(e, t, r) {
    try {
      if ("insertRule" in e) e.insertRule(t, r);else if ("appendRule" in e) {
        e.appendRule(t);
      }
    } catch (e) {
      return "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] " + e.message), !1;
    }
    return e.cssRules[r];
  },
  Vr = function Vr(e, t) {
    var r = e.cssRules.length;
    return void 0 === t || t > r ? r : t;
  },
  _r = function () {
    function e(e) {
      this.getPropertyValue = Rr, this.setProperty = Pr, this.removeProperty = jr, this.setSelector = Mr, this.element = void 0, this.sheet = void 0, this.hasInsertedRules = !1, this.cssRules = [], e && kr.add(e), this.sheet = e;
      var t = this.sheet ? this.sheet.options : {},
        r = t.media,
        n = t.meta,
        o = t.element;
      this.element = o || function () {
        var e = document.createElement("style");
        return e.textContent = "\n", e;
      }(), this.element.setAttribute("data-jss", ""), r && this.element.setAttribute("media", r), n && this.element.setAttribute("data-meta", n);
      var i = Dr();
      i && this.element.setAttribute("nonce", i);
    }
    var t = e.prototype;
    return t.attach = function () {
      if (!this.element.parentNode && this.sheet) {
        !function (e, t) {
          var r = t.insertionPoint,
            n = Tr(t);
          if (!1 !== n && n.parent) n.parent.insertBefore(e, n.node);else if (r && "number" == typeof r.nodeType) {
            var o = r,
              i = o.parentNode;
            i ? i.insertBefore(e, o.nextSibling) : "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] Insertion point is not in the DOM.");
          } else Ar().appendChild(e);
        }(this.element, this.sheet.options);
        var e = Boolean(this.sheet && this.sheet.deployed);
        this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy());
      }
    }, t.detach = function () {
      if (this.sheet) {
        var e = this.element.parentNode;
        e && e.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = "\n");
      }
    }, t.deploy = function () {
      var e = this.sheet;
      e && (e.options.link ? this.insertRules(e.rules) : this.element.textContent = "\n" + e.toString() + "\n");
    }, t.insertRules = function (e, t) {
      for (var r = 0; r < e.index.length; r++) {
        this.insertRule(e.index[r], r, t);
      }
    }, t.insertRule = function (e, t, r) {
      if (void 0 === r && (r = this.element.sheet), e.rules) {
        var n = e,
          o = r;
        if ("conditional" === e.type || "keyframes" === e.type) {
          var i = Vr(r, t);
          if (!1 === (o = Ir(r, n.toString({
            children: !1
          }), i))) return !1;
          this.refCssRule(e, i, o);
        }
        return this.insertRules(n.rules, o), o;
      }
      var a = e.toString();
      if (!a) return !1;
      var s = Vr(r, t),
        l = Ir(r, a, s);
      return !1 !== l && (this.hasInsertedRules = !0, this.refCssRule(e, s, l), l);
    }, t.refCssRule = function (e, t, r) {
      e.renderable = r, e.options.parent instanceof xr && (this.cssRules[t] = r);
    }, t.deleteRule = function (e) {
      var t = this.element.sheet,
        r = this.indexOf(e);
      return -1 !== r && (t.deleteRule(r), this.cssRules.splice(r, 1), !0);
    }, t.indexOf = function (e) {
      return this.cssRules.indexOf(e);
    }, t.replaceRule = function (e, t) {
      var r = this.indexOf(e);
      return -1 !== r && (this.element.sheet.deleteRule(r), this.cssRules.splice(r, 1), this.insertRule(t, r));
    }, t.getRules = function () {
      return this.element.sheet.cssRules;
    }, e;
  }(),
  Wr = 0,
  zr = function () {
    function e(e) {
      this.id = Wr++, this.version = "10.6.0", this.plugins = new wr(), this.options = {
        id: {
          minify: !1
        },
        createGenerateId: Or,
        Renderer: Pt ? _r : null,
        plugins: []
      }, this.generateId = Or({
        minify: !1
      });
      for (var t = 0; t < gr.length; t++) {
        this.plugins.use(gr[t], {
          queue: "internal"
        });
      }
      this.setup(e);
    }
    var t = e.prototype;
    return t.setup = function (e) {
      return void 0 === e && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = Ie({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this;
    }, t.createStyleSheet = function (e, t) {
      void 0 === t && (t = {});
      var r = t.index;
      "number" != typeof r && (r = 0 === kr.index ? 0 : kr.index + 1);
      var n = new xr(e, Ie({}, t, {
        jss: this,
        generateId: t.generateId || this.generateId,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: r
      }));
      return this.plugins.onProcessSheet(n), n;
    }, t.removeStyleSheet = function (e) {
      return e.detach(), kr.remove(e), this;
    }, t.createRule = function (e, t, r) {
      if (void 0 === t && (t = {}), void 0 === r && (r = {}), "object" == typeof e) return this.createRule(void 0, e, t);
      var n = Ie({}, r, {
        name: e,
        jss: this,
        Renderer: this.options.Renderer
      });
      n.generateId || (n.generateId = this.generateId), n.classes || (n.classes = {}), n.keyframes || (n.keyframes = {});
      var o = _t(e, t, n);
      return o && this.plugins.onProcessRule(o), o;
    }, t.use = function () {
      for (var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
        r[n] = arguments[n];
      }
      return r.forEach(function (t) {
        e.plugins.use(t);
      }), this;
    }, e;
  }();
function Ur(e) {
  var t = null;
  for (var r in e) {
    var n = e[r],
      o = typeof n;
    if ("function" === o) t || (t = {}), t[r] = n;else if ("object" === o && null !== n && !Array.isArray(n)) {
      var i = Ur(n);
      i && (t || (t = {}), t[r] = i);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var Fr = "object" == typeof CSS && null != CSS && "number" in CSS,
  qr = function qr(e) {
    return new zr(e);
  };
qr();
var Lr = Date.now(),
  Gr = "fnValues" + Lr,
  Br = "fnStyle" + ++Lr,
  Yr = "@global",
  Jr = function () {
    function e(e, t, r) {
      for (var n in this.type = "global", this.at = Yr, this.rules = void 0, this.options = void 0, this.key = void 0, this.isProcessed = !1, this.key = e, this.options = r, this.rules = new yr(Ie({}, r, {
        parent: this
      })), t) {
        this.rules.add(n, t[n]);
      }
      this.rules.process();
    }
    var t = e.prototype;
    return t.getRule = function (e) {
      return this.rules.get(e);
    }, t.addRule = function (e, t, r) {
      var n = this.rules.add(e, t, r);
      return n && this.options.jss.plugins.onProcessRule(n), n;
    }, t.indexOf = function (e) {
      return this.rules.indexOf(e);
    }, t.toString = function () {
      return this.rules.toString();
    }, e;
  }(),
  Hr = function () {
    function e(e, t, r) {
      this.type = "global", this.at = Yr, this.options = void 0, this.rule = void 0, this.isProcessed = !1, this.key = void 0, this.key = e, this.options = r;
      var n = e.substr("@global ".length);
      this.rule = r.jss.createRule(n, t, Ie({}, r, {
        parent: this
      }));
    }
    return e.prototype.toString = function (e) {
      return this.rule ? this.rule.toString(e) : "";
    }, e;
  }(),
  Xr = /\s*,\s*/g;
function $r(e, t) {
  for (var r = e.split(Xr), n = "", o = 0; o < r.length; o++) {
    n += t + " " + r[o].trim(), r[o + 1] && (n += ", ");
  }
  return n;
}
function Kr() {
  return {
    onCreateRule: function onCreateRule(e, t, r) {
      if (!e) return null;
      if (e === Yr) return new Jr(e, t, r);
      if ("@" === e[0] && "@global " === e.substr(0, "@global ".length)) return new Hr(e, t, r);
      var n = r.parent;
      return n && ("global" === n.type || n.options.parent && "global" === n.options.parent.type) && (r.scoped = !1), !1 === r.scoped && (r.selector = e), null;
    },
    onProcessRule: function onProcessRule(e, t) {
      "style" === e.type && t && (function (e, t) {
        var r = e.options,
          n = e.style,
          o = n ? n[Yr] : null;
        if (o) {
          for (var i in o) {
            t.addRule(i, o[i], Ie({}, r, {
              selector: $r(i, e.selector)
            }));
          }
          delete n[Yr];
        }
      }(e, t), function (e, t) {
        var r = e.options,
          n = e.style;
        for (var o in n) {
          if ("@" === o[0] && o.substr(0, Yr.length) === Yr) {
            var i = $r(o.substr(Yr.length), e.selector);
            t.addRule(i, n[o], Ie({}, r, {
              selector: i
            })), delete n[o];
          }
        }
      }(e, t));
    }
  };
}
var Zr = /\s*,\s*/g,
  Qr = /&/g,
  en = /\$([\w-]+)/g;
function tn() {
  function e(e, t) {
    return function (r, n) {
      var o = e.getRule(n) || t && t.getRule(n);
      return o ? (o = o).selector : ("production" !== process.env.NODE_ENV && Ct(!1, '[JSS] Could not find the referenced rule "' + n + '" in "' + (e.options.meta || e.toString()) + '".'), n);
    };
  }
  function t(e, t) {
    for (var r = t.split(Zr), n = e.split(Zr), o = "", i = 0; i < r.length; i++) {
      for (var a = r[i], s = 0; s < n.length; s++) {
        var l = n[s];
        o && (o += ", "), o += -1 !== l.indexOf("&") ? l.replace(Qr, a) : a + " " + l;
      }
    }
    return o;
  }
  function r(e, t, r) {
    if (r) return Ie({}, r, {
      index: r.index + 1
    });
    var n = e.options.nestingLevel;
    n = void 0 === n ? 1 : n + 1;
    var o = Ie({}, e.options, {
      nestingLevel: n,
      index: t.indexOf(e) + 1
    });
    return delete o.name, o;
  }
  return {
    onProcessStyle: function onProcessStyle(n, o, i) {
      if ("style" !== o.type) return n;
      var a,
        s,
        l = o,
        c = l.options.parent;
      for (var u in n) {
        var d = -1 !== u.indexOf("&"),
          p = "@" === u[0];
        if (d || p) {
          if (a = r(l, c, a), d) {
            var h = t(u, l.selector);
            s || (s = e(c, i)), h = h.replace(en, s), c.addRule(h, n[u], Ie({}, a, {
              selector: h
            }));
          } else p && c.addRule(u, {}, a).addRule(l.key, n[u], {
            selector: l.selector
          });
          delete n[u];
        }
      }
      return n;
    }
  };
}
var rn = /[A-Z]/g,
  nn = /^ms-/,
  on = {};
function an(e) {
  return "-" + e.toLowerCase();
}
function sn(e) {
  if (on.hasOwnProperty(e)) return on[e];
  var t = e.replace(rn, an);
  return on[e] = nn.test(t) ? "-" + t : t;
}
function ln(e) {
  var t = {};
  for (var r in e) {
    t[0 === r.indexOf("--") ? r : sn(r)] = e[r];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(ln) : t.fallbacks = ln(e.fallbacks)), t;
}
var cn = Fr && CSS ? CSS.px : "px",
  un = Fr && CSS ? CSS.ms : "ms",
  dn = Fr && CSS ? CSS.percent : "%";
function pn(e) {
  var t = /(-[a-z])/g,
    r = function r(e) {
      return e[1].toUpperCase();
    },
    n = {};
  for (var o in e) {
    n[o] = e[o], n[o.replace(t, r)] = e[o];
  }
  return n;
}
var hn = pn({
  "animation-delay": un,
  "animation-duration": un,
  "background-position": cn,
  "background-position-x": cn,
  "background-position-y": cn,
  "background-size": cn,
  border: cn,
  "border-bottom": cn,
  "border-bottom-left-radius": cn,
  "border-bottom-right-radius": cn,
  "border-bottom-width": cn,
  "border-left": cn,
  "border-left-width": cn,
  "border-radius": cn,
  "border-right": cn,
  "border-right-width": cn,
  "border-top": cn,
  "border-top-left-radius": cn,
  "border-top-right-radius": cn,
  "border-top-width": cn,
  "border-width": cn,
  "border-block": cn,
  "border-block-end": cn,
  "border-block-end-width": cn,
  "border-block-start": cn,
  "border-block-start-width": cn,
  "border-block-width": cn,
  "border-inline": cn,
  "border-inline-end": cn,
  "border-inline-end-width": cn,
  "border-inline-start": cn,
  "border-inline-start-width": cn,
  "border-inline-width": cn,
  "border-start-start-radius": cn,
  "border-start-end-radius": cn,
  "border-end-start-radius": cn,
  "border-end-end-radius": cn,
  margin: cn,
  "margin-bottom": cn,
  "margin-left": cn,
  "margin-right": cn,
  "margin-top": cn,
  "margin-block": cn,
  "margin-block-end": cn,
  "margin-block-start": cn,
  "margin-inline": cn,
  "margin-inline-end": cn,
  "margin-inline-start": cn,
  padding: cn,
  "padding-bottom": cn,
  "padding-left": cn,
  "padding-right": cn,
  "padding-top": cn,
  "padding-block": cn,
  "padding-block-end": cn,
  "padding-block-start": cn,
  "padding-inline": cn,
  "padding-inline-end": cn,
  "padding-inline-start": cn,
  "mask-position-x": cn,
  "mask-position-y": cn,
  "mask-size": cn,
  height: cn,
  width: cn,
  "min-height": cn,
  "max-height": cn,
  "min-width": cn,
  "max-width": cn,
  bottom: cn,
  left: cn,
  top: cn,
  right: cn,
  inset: cn,
  "inset-block": cn,
  "inset-block-end": cn,
  "inset-block-start": cn,
  "inset-inline": cn,
  "inset-inline-end": cn,
  "inset-inline-start": cn,
  "box-shadow": cn,
  "text-shadow": cn,
  "column-gap": cn,
  "column-rule": cn,
  "column-rule-width": cn,
  "column-width": cn,
  "font-size": cn,
  "font-size-delta": cn,
  "letter-spacing": cn,
  "text-decoration-thickness": cn,
  "text-indent": cn,
  "text-stroke": cn,
  "text-stroke-width": cn,
  "word-spacing": cn,
  motion: cn,
  "motion-offset": cn,
  outline: cn,
  "outline-offset": cn,
  "outline-width": cn,
  perspective: cn,
  "perspective-origin-x": dn,
  "perspective-origin-y": dn,
  "transform-origin": dn,
  "transform-origin-x": dn,
  "transform-origin-y": dn,
  "transform-origin-z": dn,
  "transition-delay": un,
  "transition-duration": un,
  "vertical-align": cn,
  "flex-basis": cn,
  "shape-margin": cn,
  size: cn,
  gap: cn,
  grid: cn,
  "grid-gap": cn,
  "row-gap": cn,
  "grid-row-gap": cn,
  "grid-column-gap": cn,
  "grid-template-rows": cn,
  "grid-template-columns": cn,
  "grid-auto-rows": cn,
  "grid-auto-columns": cn,
  "box-shadow-x": cn,
  "box-shadow-y": cn,
  "box-shadow-blur": cn,
  "box-shadow-spread": cn,
  "font-line-height": cn,
  "text-shadow-x": cn,
  "text-shadow-y": cn,
  "text-shadow-blur": cn
});
function fn(e, t, r) {
  if (null == t) return t;
  if (Array.isArray(t)) for (var n = 0; n < t.length; n++) {
    t[n] = fn(e, t[n], r);
  } else if ("object" == typeof t) {
    if ("fallbacks" === e) for (var o in t) {
      t[o] = fn(o, t[o], r);
    } else for (var i in t) {
      t[i] = fn(e + "-" + i, t[i], r);
    }
  } else if ("number" == typeof t && !1 === isNaN(t)) {
    var a = r[e] || hn[e];
    return !a || 0 === t && a === cn ? t.toString() : "function" == typeof a ? a(t).toString() : "" + t + a;
  }
  return t;
}
function vn(e) {
  void 0 === e && (e = {});
  var t = pn(e);
  return {
    onProcessStyle: function onProcessStyle(e, r) {
      if ("style" !== r.type) return e;
      for (var n in e) {
        e[n] = fn(n, e[n], t);
      }
      return e;
    },
    onChangeValue: function onChangeValue(e, r) {
      return fn(r, e, t);
    }
  };
}
var gn = "",
  mn = "",
  bn = "",
  yn = "",
  xn = Pt && "ontouchstart" in document.documentElement;
if (Pt) {
  var wn = {
      Moz: "-moz-",
      ms: "-ms-",
      O: "-o-",
      Webkit: "-webkit-"
    },
    kn = document.createElement("p").style;
  for (var En in wn) {
    if (En + "Transform" in kn) {
      gn = En, mn = wn[En];
      break;
    }
  }
  "Webkit" === gn && "msHyphens" in kn && (gn = "ms", mn = wn.ms, yn = "edge"), "Webkit" === gn && "-apple-trailing-word" in kn && (bn = "apple");
}
var Sn = gn,
  Nn = mn,
  On = bn,
  Cn = yn,
  Rn = xn;
var Pn = {
    noPrefill: ["appearance"],
    supportedProperty: function supportedProperty(e) {
      return "appearance" === e && ("ms" === Sn ? "-webkit-" + e : Nn + e);
    }
  },
  jn = {
    noPrefill: ["color-adjust"],
    supportedProperty: function supportedProperty(e) {
      return "color-adjust" === e && ("Webkit" === Sn ? Nn + "print-" + e : e);
    }
  },
  Mn = /[-\s]+(.)?/g;
function An(e, t) {
  return t ? t.toUpperCase() : "";
}
function Tn(e) {
  return e.replace(Mn, An);
}
function Dn(e) {
  return Tn("-" + e);
}
var In,
  Vn = {
    noPrefill: ["mask"],
    supportedProperty: function supportedProperty(e, t) {
      if (!/^mask/.test(e)) return !1;
      if ("Webkit" === Sn) {
        var r = "mask-image";
        if (Tn(r) in t) return e;
        if (Sn + Dn(r) in t) return Nn + e;
      }
      return e;
    }
  },
  _n = {
    noPrefill: ["text-orientation"],
    supportedProperty: function supportedProperty(e) {
      return "text-orientation" === e && ("apple" !== On || Rn ? e : Nn + e);
    }
  },
  Wn = {
    noPrefill: ["transform"],
    supportedProperty: function supportedProperty(e, t, r) {
      return "transform" === e && (r.transform ? e : Nn + e);
    }
  },
  zn = {
    noPrefill: ["transition"],
    supportedProperty: function supportedProperty(e, t, r) {
      return "transition" === e && (r.transition ? e : Nn + e);
    }
  },
  Un = {
    noPrefill: ["writing-mode"],
    supportedProperty: function supportedProperty(e) {
      return "writing-mode" === e && ("Webkit" === Sn || "ms" === Sn && "edge" !== Cn ? Nn + e : e);
    }
  },
  Fn = {
    noPrefill: ["user-select"],
    supportedProperty: function supportedProperty(e) {
      return "user-select" === e && ("Moz" === Sn || "ms" === Sn || "apple" === On ? Nn + e : e);
    }
  },
  qn = {
    supportedProperty: function supportedProperty(e, t) {
      return !!/^break-/.test(e) && ("Webkit" === Sn ? "WebkitColumn" + Dn(e) in t && Nn + "column-" + e : "Moz" === Sn && "page" + Dn(e) in t && "page-" + e);
    }
  },
  Ln = {
    supportedProperty: function supportedProperty(e, t) {
      if (!/^(border|margin|padding)-inline/.test(e)) return !1;
      if ("Moz" === Sn) return e;
      var r = e.replace("-inline", "");
      return Sn + Dn(r) in t && Nn + r;
    }
  },
  Gn = {
    supportedProperty: function supportedProperty(e, t) {
      return Tn(e) in t && e;
    }
  },
  Bn = {
    supportedProperty: function supportedProperty(e, t) {
      var r = Dn(e);
      return "-" === e[0] || "-" === e[0] && "-" === e[1] ? e : Sn + r in t ? Nn + e : "Webkit" !== Sn && "Webkit" + r in t && "-webkit-" + e;
    }
  },
  Yn = {
    supportedProperty: function supportedProperty(e) {
      return "scroll-snap" === e.substring(0, 11) && ("ms" === Sn ? "" + Nn + e : e);
    }
  },
  Jn = {
    supportedProperty: function supportedProperty(e) {
      return "overscroll-behavior" === e && ("ms" === Sn ? Nn + "scroll-chaining" : e);
    }
  },
  Hn = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack"
  },
  Xn = {
    supportedProperty: function supportedProperty(e, t) {
      var r = Hn[e];
      return !!r && Sn + Dn(r) in t && Nn + r;
    }
  },
  $n = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": ["box-orient", "box-direction"],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": ["box-orient", "box-direction"],
    "justify-content": "box-pack"
  },
  Kn = Object.keys($n),
  Zn = function Zn(e) {
    return Nn + e;
  },
  Qn = [Pn, jn, Vn, _n, Wn, zn, Un, Fn, qn, Ln, Gn, Bn, Yn, Jn, Xn, {
    supportedProperty: function supportedProperty(e, t, r) {
      var n = r.multiple;
      if (Kn.indexOf(e) > -1) {
        var o = $n[e];
        if (!Array.isArray(o)) return Sn + Dn(o) in t && Nn + o;
        if (!n) return !1;
        for (var i = 0; i < o.length; i++) {
          if (!(Sn + Dn(o[0]) in t)) return !1;
        }
        return o.map(Zn);
      }
      return !1;
    }
  }],
  eo = Qn.filter(function (e) {
    return e.supportedProperty;
  }).map(function (e) {
    return e.supportedProperty;
  }),
  to = Qn.filter(function (e) {
    return e.noPrefill;
  }).reduce(function (e, t) {
    return e.push.apply(e, ft(t.noPrefill)), e;
  }, []),
  ro = {};
if (Pt) {
  In = document.createElement("p");
  var no = window.getComputedStyle(document.documentElement, "");
  for (var oo in no) {
    isNaN(oo) || (ro[no[oo]] = no[oo]);
  }
  to.forEach(function (e) {
    return delete ro[e];
  });
}
function io(e, t) {
  if (void 0 === t && (t = {}), !In) return e;
  if ("benchmark" !== process.env.NODE_ENV && null != ro[e]) return ro[e];
  "transition" !== e && "transform" !== e || (t[e] = e in In.style);
  for (var r = 0; r < eo.length && (ro[e] = eo[r](e, In.style, t), !ro[e]); r++) {
    ;
  }
  try {
    In.style[e] = "";
  } catch (e) {
    return !1;
  }
  return ro[e];
}
var ao,
  so = {},
  lo = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
  },
  co = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
function uo(e, t, r) {
  if ("var" === t) return "var";
  if ("all" === t) return "all";
  if ("all" === r) return ", all";
  var n = t ? io(t) : ", " + io(r);
  return n || t || r;
}
function po(e, t) {
  var r = t;
  if (!ao || "content" === e) return t;
  if ("string" != typeof r || !isNaN(parseInt(r, 10))) return r;
  var n = e + r;
  if ("benchmark" !== process.env.NODE_ENV && null != so[n]) return so[n];
  try {
    ao.style[e] = r;
  } catch (e) {
    return so[n] = !1, !1;
  }
  if (lo[e]) r = r.replace(co, uo);else if ("" === ao.style[e] && ("-ms-flex" === (r = Nn + r) && (ao.style[e] = "-ms-flexbox"), ao.style[e] = r, "" === ao.style[e])) return so[n] = !1, !1;
  return ao.style[e] = "", so[n] = r, so[n];
}
function ho() {
  function e(t) {
    for (var r in t) {
      var n = t[r];
      if ("fallbacks" === r && Array.isArray(n)) t[r] = n.map(e);else {
        var o = !1,
          i = io(r);
        i && i !== r && (o = !0);
        var a = !1,
          s = po(i, zt(n));
        s && s !== n && (a = !0), (o || a) && (o && delete t[r], t[i || r] = s || n);
      }
    }
    return t;
  }
  return {
    onProcessRule: function onProcessRule(e) {
      if ("keyframes" === e.type) {
        var t = e;
        t.at = function (e) {
          return "-" === e[1] || "ms" === Sn ? e : "@" + Nn + "keyframes" + e.substr(10);
        }(t.at);
      }
    },
    onProcessStyle: function onProcessStyle(t, r) {
      return "style" !== r.type ? t : e(t);
    },
    onChangeValue: function onChangeValue(e, t) {
      return po(t, zt(e)) || e;
    }
  };
}
function fo() {
  return {
    plugins: [{
      onCreateRule: function onCreateRule(e, t, r) {
        if ("function" != typeof t) return null;
        var n = _t(e, {}, r);
        return n[Br] = t, n;
      },
      onProcessStyle: function onProcessStyle(e, t) {
        if (Gr in t || Br in t) return e;
        var r = {};
        for (var n in e) {
          var o = e[n];
          "function" == typeof o && (delete e[n], r[n] = o);
        }
        return t[Gr] = r, e;
      },
      onUpdate: function onUpdate(e, t, r, n) {
        var o = t,
          i = o[Br];
        if (i && (o.style = i(e) || {}, "development" === process.env.NODE_ENV)) for (var a in o.style) {
          if ("function" == typeof o.style[a]) {
            "production" !== process.env.NODE_ENV && Ct(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
        }
        var s = o[Gr];
        if (s) for (var l in s) {
          o.prop(l, s[l](e), n);
        }
      }
    }, Kr(), tn(), {
      onProcessStyle: function onProcessStyle(e) {
        if (Array.isArray(e)) {
          for (var t = 0; t < e.length; t++) {
            e[t] = ln(e[t]);
          }
          return e;
        }
        return ln(e);
      },
      onChangeValue: function onChangeValue(e, t, r) {
        if (0 === t.indexOf("--")) return e;
        var n = sn(t);
        return t === n ? e : (r.prop(n, e), null);
      }
    }, vn(), "undefined" == typeof window ? null : ho(), (e = function e(_e2, t) {
      return _e2.length === t.length ? _e2 > t ? 1 : -1 : _e2.length - t.length;
    }, {
      onProcessStyle: function onProcessStyle(t, r) {
        if ("style" !== r.type) return t;
        for (var n = {}, o = Object.keys(t).sort(e), i = 0; i < o.length; i++) {
          n[o[i]] = t[o[i]];
        }
        return n;
      }
    })]
  };
  var e;
}
function vo() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = e.baseClasses,
    r = e.newClasses,
    n = e.Component;
  if (!r) return t;
  var o = Ie({}, t);
  return "production" !== process.env.NODE_ENV && "string" == typeof r ? (console.error(["Material-UI: The value `".concat(r, "` ") + "provided to the classes prop of ".concat(Be(n), " is incorrect."), "You might want to use the className prop instead."].join("\n")), t) : (Object.keys(r).forEach(function (e) {
    "production" !== process.env.NODE_ENV && (!t[e] && r[e] && console.error(["Material-UI: The key `".concat(e, "` ") + "provided to the classes prop is not implemented in ".concat(Be(n), "."), "You can only override one of the following: ".concat(Object.keys(t).join(","), ".")].join("\n")), r[e] && "string" != typeof r[e] && console.error(["Material-UI: The key `".concat(e, "` ") + "provided to the classes prop is not valid for ".concat(Be(n), "."), "You need to provide a non empty string instead of: ".concat(r[e], ".")].join("\n"))), r[e] && (o[e] = "".concat(t[e], " ").concat(r[e]));
  }), o);
}
Pt && (ao = document.createElement("p"));
var go = function go(e, t, r, n) {
    var o = e.get(t);
    o || (o = new Map(), e.set(t, o)), o.set(r, n);
  },
  mo = function mo(e, t, r) {
    var n = e.get(t);
    return n ? n.get(r) : void 0;
  },
  bo = function bo(e, t, r) {
    e.get(t).delete(r);
  },
  yo = t.createContext(null);
function xo() {
  var e = t.useContext(yo);
  return "production" !== process.env.NODE_ENV && t.useDebugValue(e), e;
}
"production" !== process.env.NODE_ENV && (yo.displayName = "ThemeContext");
var wo,
  ko,
  Eo = qr(fo()),
  So = {
    disableGeneration: !1,
    generateClassName: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.disableGlobal,
        r = void 0 !== t && t,
        n = e.productionPrefix,
        o = void 0 === n ? "jss" : n,
        i = e.seed,
        a = void 0 === i ? "" : i,
        s = "" === a ? "" : "".concat(a, "-"),
        l = 0,
        c = function c() {
          return l += 1, "production" !== process.env.NODE_ENV && l >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), l;
        };
      return function (e, t) {
        var n = t.options.name;
        if (n && 0 === n.indexOf("Mui") && !t.options.link && !r) {
          if (-1 !== St.indexOf(e.key)) return "Mui-".concat(e.key);
          var i = "".concat(s).concat(n, "-").concat(e.key);
          return t.options.theme[Et] && "" === a ? "".concat(i, "-").concat(c()) : i;
        }
        if ("production" === process.env.NODE_ENV) return "".concat(s).concat(o).concat(c());
        var l = "".concat(e.key, "-").concat(c());
        return t.options.classNamePrefix ? "".concat(s).concat(t.options.classNamePrefix, "-").concat(l) : "".concat(s).concat(l);
      };
    }(),
    jss: Eo,
    sheetsCache: null,
    sheetsManager: new Map(),
    sheetsRegistry: null
  },
  No = t.createContext(So);
function Oo(e) {
  var r = e.children,
    n = e.injectFirst,
    o = void 0 !== n && n,
    i = e.disableGeneration,
    a = void 0 !== i && i,
    s = Ze(e, ["children", "injectFirst", "disableGeneration"]),
    l = Ie({}, t.useContext(No), {
      disableGeneration: a
    }, s);
  if ("production" !== process.env.NODE_ENV && ("undefined" != typeof window || l.sheetsManager || console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server.")), "production" !== process.env.NODE_ENV && l.jss.options.insertionPoint && o && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), "production" !== process.env.NODE_ENV && o && s.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !l.jss.options.insertionPoint && o && "undefined" != typeof window) {
    if (!wo) {
      var c = document.head;
      wo = document.createComment("mui-inject-first"), c.insertBefore(wo, c.firstChild);
    }
    l.jss = qr({
      plugins: fo().plugins,
      insertionPoint: wo
    });
  }
  return t.createElement(No.Provider, {
    value: l
  }, r);
}
"production" !== process.env.NODE_ENV && (No.displayName = "StylesContext"), "production" !== process.env.NODE_ENV && (Oo.propTypes = {
  children: i.node.isRequired,
  disableGeneration: i.bool,
  generateClassName: i.func,
  injectFirst: i.bool,
  jss: i.object,
  serverGenerateClassName: i.func,
  sheetsCache: i.object,
  sheetsManager: i.object,
  sheetsRegistry: i.object
}), "production" !== process.env.NODE_ENV && "production" !== process.env.NODE_ENV && (Oo.propTypes = (ko = Oo.propTypes, "production" === process.env.NODE_ENV ? ko : Ie({}, ko, ze({}, "exact-prop: ​", function (e) {
  var t = Object.keys(e).filter(function (e) {
    return !ko.hasOwnProperty(e);
  });
  return t.length > 0 ? new Error("The following props are not supported: ".concat(t.map(function (e) {
    return "`".concat(e, "`");
  }).join(", "), ". Please remove them.")) : null;
}))));
var Co = -1e9;
function Ro() {
  return Co += 1, "production" !== process.env.NODE_ENV && Co >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join("\n")), Co;
}
var Po = {};
function jo(e) {
  var t = "function" == typeof e;
  return "production" !== process.env.NODE_ENV && ("object" === Ve(e) || t || console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join("\n"))), {
    create: function create(r, n) {
      var o;
      try {
        o = t ? e(r) : e;
      } catch (e) {
        throw "production" !== process.env.NODE_ENV && !0 === t && r === Po && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join("\n")), e;
      }
      if (!n || !r.overrides || !r.overrides[n]) return o;
      var i = r.overrides[n],
        a = Ie({}, o);
      return Object.keys(i).forEach(function (e) {
        "production" !== process.env.NODE_ENV && (a[e] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(e, "` key of `theme.overrides.").concat(n, "`.")].join("\n"))), a[e] = We(a[e], i[e]);
      }), a;
    },
    options: {}
  };
}
function Mo(e, t, r) {
  var n = e.state;
  if (e.stylesOptions.disableGeneration) return t || {};
  n.cacheClasses || (n.cacheClasses = {
    value: null,
    lastProp: null,
    lastJSS: {}
  });
  var o = !1;
  return n.classes !== n.cacheClasses.lastJSS && (n.cacheClasses.lastJSS = n.classes, o = !0), t !== n.cacheClasses.lastProp && (n.cacheClasses.lastProp = t, o = !0), o && (n.cacheClasses.value = vo({
    baseClasses: n.cacheClasses.lastJSS,
    newClasses: t,
    Component: r
  })), n.cacheClasses.value;
}
function Ao(e, t) {
  var r = e.state,
    n = e.theme,
    o = e.stylesOptions,
    i = e.stylesCreator,
    a = e.name;
  if (!o.disableGeneration) {
    var s = mo(o.sheetsManager, i, n);
    s || (s = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, go(o.sheetsManager, i, n, s));
    var l = Ie({}, i.options, o, {
      theme: n,
      flip: "boolean" == typeof o.flip ? o.flip : "rtl" === n.direction
    });
    l.generateId = l.serverGenerateClassName || l.generateClassName;
    var c = o.sheetsRegistry;
    if (0 === s.refs) {
      var u;
      o.sheetsCache && (u = mo(o.sheetsCache, i, n));
      var d = i.create(n, a);
      u || ((u = o.jss.createStyleSheet(d, Ie({
        link: !1
      }, l))).attach(), o.sheetsCache && go(o.sheetsCache, i, n, u)), c && c.add(u), s.staticSheet = u, s.dynamicStyles = Ur(d);
    }
    if (s.dynamicStyles) {
      var p = o.jss.createStyleSheet(s.dynamicStyles, Ie({
        link: !0
      }, l));
      p.update(t), p.attach(), r.dynamicSheet = p, r.classes = vo({
        baseClasses: s.staticSheet.classes,
        newClasses: p.classes
      }), c && c.add(p);
    } else r.classes = s.staticSheet.classes;
    s.refs += 1;
  }
}
function To(e, t) {
  var r = e.state;
  r.dynamicSheet && r.dynamicSheet.update(t);
}
function Do(e) {
  var t = e.state,
    r = e.theme,
    n = e.stylesOptions,
    o = e.stylesCreator;
  if (!n.disableGeneration) {
    var i = mo(n.sheetsManager, o, r);
    i.refs -= 1;
    var a = n.sheetsRegistry;
    0 === i.refs && (bo(n.sheetsManager, o, r), n.jss.removeStyleSheet(i.staticSheet), a && a.remove(i.staticSheet)), t.dynamicSheet && (n.jss.removeStyleSheet(t.dynamicSheet), a && a.remove(t.dynamicSheet));
  }
}
function Io(e, r) {
  var n,
    o = t.useRef([]),
    i = t.useMemo(function () {
      return {};
    }, r);
  o.current !== i && (o.current = i, n = e()), t.useEffect(function () {
    return function () {
      n && n();
    };
  }, [i]);
}
function Vo(e) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = r.name,
    o = r.classNamePrefix,
    i = r.Component,
    a = r.defaultTheme,
    s = void 0 === a ? Po : a,
    l = Ze(r, ["name", "classNamePrefix", "Component", "defaultTheme"]),
    c = jo(e),
    u = n || o || "makeStyles";
  c.options = {
    index: Ro(),
    name: n,
    meta: u,
    classNamePrefix: u
  };
  var d = function d() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      r = xo() || s,
      o = Ie({}, t.useContext(No), l),
      a = t.useRef(),
      u = t.useRef();
    Io(function () {
      var t = {
        name: n,
        state: {},
        stylesCreator: c,
        stylesOptions: o,
        theme: r
      };
      return Ao(t, e), u.current = !1, a.current = t, function () {
        Do(t);
      };
    }, [r, c]), t.useEffect(function () {
      u.current && To(a.current, e), u.current = !0;
    });
    var d = Mo(a.current, e.classes, i);
    return "production" !== process.env.NODE_ENV && t.useDebugValue(d), d;
  };
  return d;
}
var _o = function () {
  for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, r = void 0 === t ? {} : t, n = e.mixins, o = void 0 === n ? {} : n, i = e.palette, a = void 0 === i ? {} : i, s = e.spacing, l = e.typography, c = void 0 === l ? {} : l, u = Ze(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = it(a), p = et(r), h = mt(s), f = We({
      breakpoints: p,
      direction: "ltr",
      mixins: tt(p, h, o),
      overrides: {},
      palette: d,
      props: {},
      shadows: ut,
      typography: lt(d, c),
      spacing: h,
      shape: dt,
      transitions: wt,
      zIndex: kt
    }, u), v = arguments.length, g = new Array(v > 1 ? v - 1 : 0), m = 1; m < v; m++) {
    g[m - 1] = arguments[m];
  }
  if (f = g.reduce(function (e, t) {
    return We(e, t);
  }, f), "production" !== process.env.NODE_ENV) {
    var b = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"],
      y = function e(t, r) {
        var n,
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        for (n in t) {
          var i = t[n];
          1 === o ? 0 === n.indexOf("Mui") && i && e(i, n, o + 1) : -1 !== b.indexOf(n) && Object.keys(i).length > 0 && ("production" !== process.env.NODE_ENV && console.error(["Material-UI: The `".concat(r, "` component increases ") + "the CSS specificity of the `".concat(n, "` internal state."), "You can not override it like this: ", JSON.stringify(t, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
            root: ze({}, "&$".concat(n), i)
          }, null, 2), "", "https://material-ui.com/r/pseudo-classes-guide"].join("\n")), t[n] = {});
        }
      };
    y(f.overrides);
  }
  return f;
}();
var Wo,
  zo = function zo(e) {
    var r = e.Element,
      n = e.defaultValue,
      o = T(e, ["Element", "defaultValue"]),
      _t$useState5 = t.useState(n),
      _t$useState6 = _slicedToArray(_t$useState5, 2),
      i = _t$useState6[0],
      a = _t$useState6[1];
    return t.createElement(r, A(A({}, o), {}, {
      value: i,
      onChange: a
    }));
  },
  Uo = function Uo(e) {
    var r = function r(_r2) {
      var n = _r2.defaultValue,
        o = _r2.value,
        i = _r2.onChange,
        a = T(_r2, ["defaultValue", "value", "onChange"]);
      return i || "none" !== o ? t.createElement(e, A({
        value: o || n,
        onChange: i || function () {}
      }, a)) : t.createElement(zo, A({
        Element: e,
        defaultValue: n
      }, a));
    };
    return r.propTypes = A(A({}, e.propTypes), {}, {
      defaultValue: e.propTypes.value,
      onChange: i.func
    }), r.defaultProps = A(A({}, e.defaultProps), {}, {
      defaultValue: void 0,
      onChange: void 0
    }), r;
  },
  Fo = function (e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return function (n) {
      var o = r.defaultTheme,
        a = r.withTheme,
        s = void 0 !== a && a,
        l = r.name,
        c = Ze(r, ["defaultTheme", "withTheme", "name"]);
      if ("production" !== process.env.NODE_ENV && void 0 === n) throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join("\n"));
      var u = l;
      if ("production" !== process.env.NODE_ENV && !l) {
        var d = Be(n);
        void 0 !== d && (u = d);
      }
      var p = Vo(e, Ie({
          defaultTheme: o,
          Component: n,
          name: l || n.displayName,
          classNamePrefix: u
        }, c)),
        h = t.forwardRef(function (e, r) {
          e.classes;
          var i,
            a = e.innerRef,
            c = Ze(e, ["classes", "innerRef"]),
            u = p(Ie({}, n.defaultProps, e)),
            d = c;
          return ("string" == typeof l || s) && (i = xo() || o, l && (d = Nt({
            theme: i,
            name: l,
            props: c
          })), s && !d.theme && (d.theme = i)), t.createElement(n, Ie({
            ref: a || r,
            classes: u
          }, d));
        });
      return "production" !== process.env.NODE_ENV && (h.propTypes = {
        classes: i.object,
        innerRef: De(i.oneOfType([i.func, i.object]), function (e) {
          return e.innerRef, null;
        })
      }), "production" !== process.env.NODE_ENV && (h.displayName = "WithStyles(".concat(Be(n), ")")), N(h, n), "production" !== process.env.NODE_ENV && (h.Naked = n, h.options = r, h.useStyles = p), h;
    };
  }({
    root: {
      width: 100
    }
  }, Ie({
    defaultTheme: _o
  }, Wo))(x),
  qo = v({
    root: {
      display: "flex",
      flexDirection: "row"
    },
    colorinputRaw: {
      paddingRight: 4
    }
  }),
  Lo = function Lo(e) {
    var r,
      n,
      o = e.value,
      i = e.format,
      a = e.onChange,
      s = e.disableAlpha,
      l = e.enableErrorDisplay,
      c = e.forwardRef,
      u = e.disablePlainColor,
      d = T(e, ["value", "format", "onChange", "disableAlpha", "enableErrorDisplay", "forwardRef", "disablePlainColor"]),
      p = qo(),
      _se2 = se(),
      h = _se2.t,
      f = _se2.i18n,
      v = re(o, s, h, f.language, u),
      g = function g(e) {
        if ("plain" === i) a(e.target.value);else if ("hex" === i) a("#".concat(e.target.value));else {
          var t = e.target.id,
            r = Number(e.target.value),
            o = {};
          Object.keys(n).forEach(function (e) {
            var i = n[e].value;
            e === t && ((i = r) < n[e].min && (i = n[e].min), i > n[e].max && (i = n[e].max)), o[e] = i;
          }), a(o);
        }
      },
      m = function m(e, r, n, o, i) {
        return t.createElement(t.Fragment, null, t.createElement(k, {
          htmlFor: e,
          className: "muicc-colorinput-label",
          "data-testid": "colorinput-label"
        }, r), t.createElement(E, j({
          id: e,
          name: e,
          className: "muicc-colorinput-input",
          label: r,
          value: n,
          placeholder: r,
          inputProps: {
            "aria-label": "color-".concat(r),
            "data-testid": "colorinput-input"
          },
          onChange: g,
          startAdornment: i && o && t.createElement(S, {
            position: "start"
          }, o)
        }, d)));
      };
    if ("plain" === i) r = m("color-plain", "Color", v.raw);else {
      n = function (e, t, r) {
        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function (e) {
            return e;
          },
          o = re(e, r, n),
          i = {};
        if ("rgb" === t) i.r = {
          value: o.rgb[0],
          format: "integer",
          min: 0,
          max: 255,
          name: n("R")
        }, i.g = {
          value: o.rgb[1],
          format: "integer",
          min: 0,
          max: 255,
          name: n("G")
        }, i.b = {
          value: o.rgb[2],
          format: "integer",
          min: 0,
          max: 255,
          name: n("B")
        };else if ("hsv" === t) i.h = {
          value: o.hsv[0],
          format: "integer",
          min: 0,
          max: 360,
          name: n("H"),
          unit: "°"
        }, i.s = {
          value: o.hsv[1],
          format: "integer",
          min: 0,
          max: 100,
          name: n("S"),
          unit: "%"
        }, i.v = {
          value: o.hsv[2],
          format: "integer",
          min: 0,
          max: 100,
          name: n("V"),
          unit: "%"
        };else if ("hsl" === t) i.h = {
          value: o.hsl[0],
          format: "integer",
          min: 0,
          max: 360,
          name: n("H"),
          unit: "°"
        }, i.s = {
          value: o.hsl[1],
          format: "integer",
          min: 0,
          max: 100,
          name: n("S"),
          unit: "%"
        }, i.l = {
          value: o.hsl[2],
          format: "integer",
          min: 0,
          max: 100,
          name: n("L"),
          unit: "%"
        };else if ("hex" === t) {
          var a = o.hex;
          o.raw && "string" == typeof o.raw && o.raw.startsWith("#") && (a = o.raw.substring(1)), i.hex = {
            value: a,
            format: "hex",
            name: n("HEX"),
            unit: "#"
          };
        } else i.value = n(o.value), i.format = "unknown";
        return i;
      }(v, i, s, h);
      var b = Object.keys(n);
      r = t.createElement("div", {
        ref: c,
        className: p.root
      }, b.map(function (e) {
        return t.createElement(x, {
          key: e,
          className: "muicc-colorinput-raw ".concat(p.colorinputRaw),
          error: !!v.error
        }, m(e, n[e].name, n[e].value, n[e].unit, 1 === b.length));
      }));
    }
    return t.createElement(Fo, {
      error: !!v.error,
      "data-testid": "colorinput"
    }, r, l && v.error && t.createElement(w, {
      id: "component-error-text"
    }, v.error));
  };
Lo.propTypes = {
  value: ne,
  format: i.string,
  onChange: i.func.isRequired,
  disableAlpha: i.bool,
  enableErrorDisplay: i.bool,
  forwardRef: i.shape({
    current: i.elementType
  }),
  disablePlainColor: i.bool
}, Lo.defaultProps = {
  value: "none",
  format: "plain",
  forwardRef: void 0,
  disableAlpha: !1,
  enableErrorDisplay: !0,
  disablePlainColor: !1
};
var Go = Uo(Lo),
  Bo = v({
    root: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      padding: "8px 0 0 8px"
    },
    paletteButton: {
      margin: "0 8px 8px 0",
      padding: 0
    }
  }),
  Yo = function Yo(e) {
    var r = e.size,
      n = e.borderWidth,
      o = e.palette,
      i = e.onSelect,
      a = e.disableAlpha,
      s = Bo(),
      _se3 = se(),
      l = _se3.t;
    return t.createElement("div", {
      className: s.root
    }, Object.keys(o).map(function (e) {
      return t.createElement(ce, {
        size: r,
        key: "".concat(e),
        color: o[e],
        className: "muicc-palette-button ".concat(s.paletteButton),
        borderWidth: n,
        tooltip: e,
        disableAlpha: a,
        onClick: function onClick() {
          return function (e) {
            var t = l(e);
            i && i(t, o[e]);
          }(e);
        }
      });
    }));
  };
Yo.propTypes = {
  borderWidth: i.number,
  size: i.number,
  palette: oe.isRequired,
  forwardRef: i.shape({
    current: i.elementType
  }),
  onSelect: i.func,
  disableAlpha: i.bool
}, Yo.defaultProps = {
  borderWidth: 0,
  size: 24,
  forwardRef: void 0,
  onSelect: void 0,
  disableAlpha: !1
};
var Jo = v(function () {
  return {
    root: {
      width: "100%",
      height: 16,
      padding: 0
    },
    rail: {
      height: 16,
      opacity: 1,
      background: "rgba(0, 0, 0, 0) linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100% ) repeat scroll 0% 0%",
      borderRadius: 0
    },
    track: {
      height: 16,
      opacity: 0,
      borderRadius: 4,
      backgroundColor: "transparent"
    },
    thumb: {
      width: 16,
      height: 16,
      marginTop: 0,
      marginLeft: -8,
      backgroundColor: "#f0f0f0",
      boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
      "&:focus": {
        boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
      }
    }
  };
});
function Ho(e) {
  var r = Jo();
  return t.createElement(R, j({}, e, {
    classes: {
      root: r.root,
      rail: r.rail,
      track: r.track,
      thumb: r.thumb
    }
  }));
}
var Xo = v({
  root: {
    color: "#666",
    width: "100%",
    height: 16,
    padding: 0,
    background: "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%)",
    backgroundSize: "8px 8px",
    backgroundColor: "white",
    backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px"
  },
  rail: {
    height: 16,
    opacity: 1,
    background: function background(e) {
      return "rgba(0, 0, 0, 0) linear-gradient(to right, ".concat(e.color, "00 0%, ").concat(e.color, " 100%) repeat scroll 0% 0%");
    },
    borderRadius: 0
  },
  track: {
    height: 16,
    opacity: 0,
    borderRadius: 4
  },
  thumb: {
    width: 16,
    height: 16,
    marginTop: 0,
    marginLeft: -8,
    backgroundColor: "#f0f0f0",
    boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
    "&:focus": {
      boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
    }
  }
});
function $o(e) {
  var r = e.color,
    n = T(e, ["color"]),
    o = Xo({
      color: r
    });
  return t.createElement(R, j({}, n, {
    classes: {
      root: o.root,
      rail: o.rail,
      track: o.track,
      thumb: o.thumb
    }
  }));
}
$o.propTypes = {
  color: ne.isRequired
};
var Ko = v(function (e) {
    return {
      root: {
        backgroundColor: e.palette.background.paper,
        position: "relative",
        width: "min-content",
        height: "min-content",
        padding: "0px"
      },
      container: {
        justifyContent: "space-around",
        overflow: "hidden",
        width: function width(e) {
          return e.boxWidth;
        },
        padding: 0
      },
      colorboxHsvGradient: {
        width: function width(e) {
          return "calc(".concat(e.boxWidth, "px - 16px)");
        },
        height: "calc(128px - 16px)",
        margin: 8
      },
      colorboxSliders: {
        width: function width(e) {
          return e.boxWidth;
        },
        padding: "8px 8px 4px 8px"
      },
      colorboxInputs: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        padding: "8px 4px 8px 8px",
        justifyContent: "space-between"
      },
      colorboxInput: {},
      colorboxColorBg: {
        width: 48,
        height: 48,
        background: "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%)",
        backgroundSize: "8px 8px",
        backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
        backgroundColor: "white",
        borderRadius: 4
      },
      colorboxColor: {
        width: 48,
        height: 48,
        background: function background(e) {
          return e.colorError ? "repeating-linear-gradient(\n      135deg,\n      transparent,\n      transparent 29px,\n      #f44336 29px,\n      #f44336 32px\n    )" : "none";
        },
        backgroundColor: function backgroundColor(e) {
          return e.colorError ? "transparent" : e.backgroundColor;
        },
        borderRadius: 4,
        border: function border(e) {
          return e.colorError ? "2px solid #f44336" : "none";
        }
      },
      colorboxControls: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        padding: 8,
        "&> button": {
          marginLeft: "auto"
        }
      },
      colorboxError: {
        color: "#f44336",
        lineHeight: "36.5px"
      }
    };
  }),
  Zo = function Zo(e) {
    var _t$useState7, _t$useState8;
    var r,
      n = e.value,
      o = e.palette,
      i = e.inputFormats,
      a = e.deferred,
      s = e.onChange,
      l = e.disableAlpha,
      c = T(e, ["value", "palette", "inputFormats", "deferred", "onChange", "disableAlpha"]),
      _se4 = se(),
      u = _se4.t,
      d = _se4.i18n,
      p = re(n, l, u, d.language),
      h = s;
    a && ((_t$useState7 = t.useState(p), _t$useState8 = _slicedToArray(_t$useState7, 2), p = _t$useState8[0], h = _t$useState8[1], _t$useState7), r = s);
    var _p = p,
      f = _p.hsv,
      _p2 = p,
      v = _p2.alpha;
    v = void 0 === v ? 100 : Math.floor(100 * v);
    var m = te(p, "hex", !0),
      x = p.css.backgroundColor,
      w = Ko({
        boxWidth: 320,
        backgroundColor: x,
        colorError: !!p.error
      }),
      k = function k(e) {
        var t = ee(e);
        h(t);
      };
    return t.createElement(b, j({
      p: 2,
      className: w.root
    }, c), t.createElement(b, {
      className: w.container
    }, t.createElement(he, {
      className: "muicc-colorbox-hsvgradient ".concat(w.colorboxHsvGradient),
      color: p,
      onChange: function onChange(e) {
        var t = ee(e, "hsv");
        h(t);
      }
    }), t.createElement("div", {
      className: "muicc-colorbox-sliders ".concat(w.colorboxSliders)
    }, t.createElement(Ho, {
      "data-testid": "hueslider",
      "aria-label": "color slider",
      value: f[0],
      min: 0,
      max: 360,
      onChange: function onChange(e, t) {
        var r = ee([t, p.hsv[1], p.hsv[2]], "hsv");
        h(r);
      }
    }), !l && t.createElement($o, {
      "data-testid": "alphaslider",
      color: m,
      valueLabelDisplay: "auto",
      "aria-label": "alpha slider",
      value: v,
      min: 0,
      max: 100,
      onChange: function onChange(e, t) {
        var r = t / 100,
          n = ee([p.rgb[0], p.rgb[1], p.rgb[2], r], "rgb");
        h(n);
      }
    })), i && t.createElement("div", {
      className: "muicc-colorbox-inputs  ".concat(w.colorboxInputs)
    }, t.createElement("div", {
      className: "muicc-colorbox-colorBg ".concat(w.colorboxColorBg)
    }, t.createElement("div", {
      className: "muicc-colorbox-color ".concat(w.colorboxColor)
    })), i.map(function (e) {
      return t.createElement(Go, {
        key: e,
        value: p,
        format: e,
        disableAlpha: !0,
        enableErrorDisplay: !1,
        className: "muicc-colorbox-input ".concat(w.colorboxInput),
        onChange: k
      });
    })), o && t.createElement(t.Fragment, null, t.createElement(y, null), t.createElement(Yo, {
      size: 26.65,
      palette: o,
      onSelect: function onSelect(e, t) {
        var r = ee(t);
        r.name = e, h(r);
      },
      disableAlpha: l
    })), t.createElement("div", {
      className: "muicc-colorbox-controls ".concat(w.colorboxControls)
    }, p.error && t.createElement("span", {
      className: "muicc-colorbox-error ".concat(w.colorboxError),
      "data-testid": "colorbox-error"
    }, u(p.error)), a && t.createElement(g, {
      onClick: function onClick() {
        r(p);
      }
    }, u("Set")))));
  };
Zo.propTypes = {
  value: ne,
  deferred: i.bool,
  palette: oe,
  inputFormats: ie,
  onChange: i.func.isRequired,
  disableAlpha: i.bool
}, Zo.defaultProps = {
  value: void 0,
  deferred: !1,
  palette: void 0,
  inputFormats: ["hex", "rgb"],
  disableAlpha: !1
};
var Qo = Uo(Zo),
  ei = v({
    root: {
      display: "flex",
      flexDirection: "row",
      width: "max-content"
    },
    colorpickerButton: {
      margin: 6
    }
  }),
  ti = function ti(e) {
    var i = e.value,
      a = e.disableTextfield,
      s = e.deferred,
      l = e.palette,
      c = e.inputFormats,
      u = e.openAtStart,
      d = e.onChange,
      p = e.onOpen,
      v = e.doPopup,
      g = e.disableAlpha,
      m = e.hideTextfield,
      b = e.disablePlainColor,
      y = ei(),
      x = r(null),
      _n2 = n(!1),
      _n3 = _slicedToArray(_n2, 2),
      w = _n3[0],
      k = _n3[1],
      _se5 = se(),
      E = _se5.t,
      S = _se5.i18n,
      N = re(i, g, E, S.language, b),
      O = function (e, t) {
        var r = t ? "color-".concat(e.hex) : e.name;
        return r.startsWith("color-") ? r = "string" == typeof e.raw && e.raw.startsWith("#") ? e.raw : te(e, "hex") : "none" === r && (r = e.raw), r;
      }(N, b);
    o(function () {
      u && k(!0);
    }, [u]);
    var C = function C() {
        var e = Boolean(x.current);
        k(e), p && p(e);
      },
      R = function R() {
        k(!1), p && p(!1);
      },
      P = t.createElement(Qo, {
        value: N,
        style: {
          position: "relative"
        },
        deferred: s,
        palette: l,
        inputFormats: c,
        disableAlpha: g,
        onChange: function onChange(e) {
          d(e), s && R();
        }
      });
    P = v ? v(P) : t.createElement(f, {
      id: "color-popover",
      open: w,
      anchorEl: x.current,
      onClose: R,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, P);
    var j = null;
    return m || (j = a ? t.createElement("div", {
      role: "button",
      "data-testid": "colorpicker-noinput",
      onClick: C
    }, N.raw) : t.createElement(h, {
      color: "primary",
      value: O,
      onChange: function onChange(e) {
        d(e.target.value);
      },
      "data-testid": "colorpicker-input"
    })), t.createElement("div", {
      ref: x,
      className: y.root
    }, t.createElement(ce, {
      "data-testid": "colorpicker-button",
      className: "muicc-colorpicker-button ".concat(y.colorpickerButton),
      color: N,
      onClick: C
    }), j, P);
  };
ti.propTypes = {
  value: ne,
  disableTextfield: i.bool,
  deferred: i.bool,
  palette: oe,
  inputFormats: ie,
  onChange: i.func.isRequired,
  onOpen: i.func,
  openAtStart: i.bool,
  doPopup: i.func,
  disableAlpha: i.bool,
  hideTextfield: i.bool,
  disablePlainColor: i.bool
}, ti.defaultProps = {
  value: "none",
  disableTextfield: !1,
  deferred: !1,
  palette: void 0,
  inputFormats: ["hex", "rgb"],
  onOpen: void 0,
  openAtStart: !1,
  doPopup: void 0,
  disableAlpha: !1,
  hideTextfield: !1,
  disablePlainColor: !1
};
var ri = Uo(ti);
export { Qo as ColorBox, ce as ColorButton, Go as ColorInput, Yo as ColorPalette, ri as ColorPicker, ee as createColor, se as useTranslate };